import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportingService } from '../reporting-service.service';
import { ReportMainData } from 'app/ReportingModel/ReportFiltering';
import { SavedReportDto, SaveReportInputDto, SaveReportMainDto } from 'app/ReportingModel/SavedReportDto';
import { DatePipe } from '@angular/common';
import { ModalOptions, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GenerateReportDto, GenerateReportMainDto, GenerateReportInputDto } from 'app/ReportingModel/GenerateReportDto';
import { unescape } from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RoleConfigService } from 'app/views/role-config/role-config.service';
import { FormGroup, FormControl } from '@angular/forms';
import { SharedServicesService } from '../../../shared/sharedservices/shared-services.service';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { IndividualService } from '../../individual/individual.service';
import { OrderPipe } from 'ngx-order-pipe';
import {
    FavouriteJobsAddActionDto,
    FavouriteJobsDto,
    FavouriteJobsTableTypeDto,
} from 'app/Models/FavouriteJobsDto';
import { EngagementService } from '../../engagement/engagement.service';
import { favEngImageSrc } from 'app/shared/enum';
import { UltimateCustomerDto, UltimateCustomerSearchDto } from 'app/ReportingModel/UltimateCustomerDto';
import { CustomerDto, CustomerSearchDto } from 'app/ReportingModel/CustomerDto';
import { ThemeService } from 'app/shared/theme/theme.service';
import { DARK_PATH, LIGHT_PATH } from 'app/app-constants';
import { SearchResourceResultDto, SearchResourceDto } from 'app/ReportingModel/SearchResourceDto';
import { ResourceDto } from '../../../Models/ResourceDto';
import { SearchCouncellorResultDto, SearchCouncellorDto } from 'app/ReportingModel/SearchCouncellorDto';
import { SearchEngagementResultDto, SearchEngagementDto } from 'app/ReportingModel/SearchEngagementDto';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ReportVM } from 'app/ReportingModel/ReportVM';
import { Report } from 'app/ReportingModel/ReportConstantsDto';
import { SearchBookingDto } from 'app/ReportingModel/SearchBookingDto';
import { SearchMERABookingDto, SearchMERABookingResultDto } from 'app/ReportingModel/SearchMERABookingDto';
import { RoleTypeEnum } from 'app/shared/enum';
import { ResourceDetailsDto } from 'app/ReportingModel/ResourceDetailsDto';
import { EmployeeDepartmentSearchDto, SearchEmployeeDepartmentResultDto } from 'app/ReportingModel/EmployeeDepartmentSearchDto';

@Component({
    selector: 'app-report-new-report',
    templateUrl: './report-new-report.component.html',
    styleUrls: ['./report-new-report.component.scss']
})
export class NewReportComponent implements OnInit {
    selectedResSLIds:any[] = null;
    selectedResSSLIds:any[] = null;
    selectedResCompetencyCode:any[] = null;
    selectedResSubAreaCode :any[] = null;
    selectedResCountryCode :any[] = null;

    selectedEngSLIds:any[] = null;
    selectedEngSSLIds:any[] = null;
    selectedEngCompetencyCode:any[] = null;
    selectedEngSubAreaCode :any[] = null;
    selectedEngCountryCode :any[] = null;

    isRemoveSelectedEngItems: boolean = false;
    isRemoveSelectedEngMangerItems: boolean = false;
    isRemoveSelectedEngPatnerItems: boolean = false;
    isRemoveSelectedEngCustItems: boolean = false;
    isRemoveSelectedEngUltCustItems: boolean = false;
    isRemoveSelectedResItems: boolean = false;
    isRemoveSelectedCouncellorItems: boolean = false;
    isRemoveSelectedOthRequestorNameItems: boolean = false;
    isRemoveSelectedOthRetainBookingIdItems: boolean = false;
    isRemoveSelectedOthMERABookingIdItems: boolean = false;

    isRemoveSelectedOthSubmittedbyItems: boolean = false;
    isRemoveSelectedOthRejectedbyItems: boolean = false;
    isRemoveSelectedOthApprovedbyItems: boolean = false;
    isRemoveSelectedResEmployeeDepartmentItems: boolean = false;

    items: ReportVM[]
    selectedResItems: ReportVM[] = [];
    selectedCounsellorItems: ReportVM[] = [];
    selectedEngItems: ReportVM[] = [];
    selectedEngManagerItems: ReportVM[] = [];
    selectedEngPartnerItems: ReportVM[] = [];
    selectedEngCustomerItems: ReportVM[] = [];
    selectedEngUltCustItems: ReportVM[] = [];
    RoleId: number;
    @Input() ReportMainData: ReportMainData;
    dirtyFlag: boolean = false;
    dropdownSettings: IDropdownSettings = {};
    selectedTabVal: string = ''; // Default selected tab
    reportdata: SaveReportMainDto;
    generateReportdata: GenerateReportMainDto;
    messageBody = '';
    messageTitle = '';
    modalDisplayed = false;
    modalOption: ModalOptions = {};
    modalRef: BsModalRef;
    savedReportName: string = '';
    savedReportComments: string = '';
    popupMessageBody = '';
    popupMessageTitle = '';
    @ViewChild('template1') template1: TemplateRef<any>;
    strultimateCustomer: string;
    strultimateCustomerName: string;

    // res 
    resSubAreaList = [];
    resManageCountryList = [];
    resManageCountryLoader: boolean = false;
    resLegalEntityList = [];
    resLegalEntityLoader: boolean = false;
    resDepartmentList = [];
    resDepartmentLoader: boolean = false;
    resServiceLineList = [];
    resServiceLineLoader: boolean = false;
    resSubServiceLineList = [];
    resSubServiceLineLoader: boolean = false;
    resLevelList = [];
    resLevelLoader: boolean = false;
    resGradeList = [];
    resGradeLoader: boolean = false;
    resCompetencyList = [];
    resCompetencyLoader: boolean = false;
    resCompanyCodeList = [];
    resCompanyCodeLoader: boolean = false;
    resEconomicLocationList = [];
    resEconomicLocationLoader: boolean = false;
    resRankList = [];
    resRankLoader: boolean = false;
    resViewCostCenterList = [];
    resViewCostCenterLoader: boolean = false;
    resViewRankList = [];
    resViewRankLoader: boolean = false;
    resEmployeeStatusList = [];
    resEmployeeStatusLoader: boolean = false;
    resEmployeeTypeList = [];
    resEmployeeTypeLoader: boolean = false;

    resOfficeLocationItems = [];
    resOfficeLocationLoader: boolean = false;
    resEmployeeTypeSelectedItems = [];
    resEmployeeStatusSelectedItems = [];

    resSubAreaSelectedItems = [];
    resManageCountrySelectedItems = [];
    resEconomicLocationSelectedItems = [];
    resLegalEntitySelectedItems = [];
    resCompanyCodeSelectedItems = [];
    resServiceLineSelectedItems = [];
    resSubServiceLineSelectedItems = [];
    resCompetencySelectedItems = [];
    resLevelSelectedItems = [];
    resGradeSelectedItems = [];
    resRankSelectedItems = [];
    resDepartmentSelectedItems = [];
    resViewCostCenterSelectedItems = [];
    resOfficeLocationSelectedItems = [];
    resGDSRegionAlignmentList = [];
    resGDSRegionAlignmentLoader: boolean = false;
    resGDSRegionAlignmentSelectedItems = [];
    resAvailability = 0;
    resRegionList = [];
    resRegionLoader: boolean = false;
    resRegionSelectedItems = [];
    resSubRegionList = [];
    resSubRegionSelectedItems = [];
    resSubRegionLoader: boolean = false;
    // Engagement  
    engManageCountryList = [];
    engManageCountryLoader: boolean = false;
    engManageCountrySelectedItems = [];
    engServiceLineList = [];
    engServiceLineLoader: boolean = false;
    engServiceLineSelectedItems = [];
    engSubServiceLineList = [];
    engSubServiceLineLoader: boolean = false;
    engSubServiceLineSelectedItems = [];
    engCompetencyList = [];
    engCompetencyLoader: boolean = false;
    engCompetencySelectedItems = [];
    engCostCenterList = [];
    engCostCenterLoader: boolean = false;
    engCostCenterSelectedItems = [];
    engEngagementTypesSelectedItems = [];
    engEngagementSubTypesSelectedItems = [];
    engRegionList = [];
    engRegionLoader: boolean = false;
    engRegionSelectedItems = [];
    engJobStatusList = [];
    engJobStatusLoader: boolean = false;
    engJobStatusSelectedItems = [];
    engCustomerIndustryList = [];
    engCustomerIndustryLoader: boolean = false;
    engCustomerIndustrySelectedItems = [];
    engCustomerPriorityStatusList = [];
    engCustomerPriorityStatusLoader: boolean = false;
    engCustomerPriorityStatusSelectedItems = [];
    //Other
    othBookingCategoryList = [];
    othBookingCategoryLoader: boolean = false;
    othBookingCategorySelectedItems = [];
    othBookingTypeList = [];
    othBookingTypeLoader: boolean = false;
    othBookingTypeSelectedItems = [];
    othMERAActionList = [];
    othMERAActionLoader: boolean = false;
    othMERAActionSelectedItems = [];
    othMeraRequestModeList = [];
    othMeraRequestModeLoader: boolean = false;
    othMeraRequestModeSelectedItems = [];
    othMeraBookingStatusList = [];
    othMeraBookingStatusLoader: boolean = false;
    othMeraBookingStatusSelectedItems = [];
    othMeraStatusInformationList = [];
    othMeraStatusInformationLoader: boolean = false;
    othMeraStatusInformationSelectedItems = [];

    range = new FormGroup({
        start: new FormControl(null),
        end: new FormControl(null),
    });
    submittedOnrange = new FormGroup({
        start: new FormControl(null),
        end: new FormControl(null),
    });
    approvedOnrange = new FormGroup({
        start: new FormControl(null),
        end: new FormControl(null),
    });
    rejectedOnrange = new FormGroup({
        start: new FormControl(null),
        end: new FormControl(null),
    });
    startDate: any;
    endDate: any;

    // EmployeeDepartment
    searchBarResEmployeeDepartment: string = '';
    resEmployeeDepartment: EmployeeDepartmentSearchDto;
    sortedResEmployeeDepartmentList: SearchEmployeeDepartmentResultDto[];
    addFavouritResEmployeeDepartmentResults: any[] = [];
    showFavouriteResEmployeeDepartmentList: boolean = false;
    showSearchResEmployeeDepartmentLoader: boolean = false;
    selectedResEmployeeDepartmentItems: ReportVM[] = [];

    // VO Other Start

    // Submitted by
    searchBarOthSubmittedby: string = '';
    OthSubmittedby: SearchResourceDto;
    sortedOthSubmittedbyList: SearchResourceResultDto[];
    addFavouritOthSubmittedbyResults: any[] = [];
    showFavouriteOthSubmittedbyList: boolean = false;
    showSearchOthSubmittedbyLoader: boolean = false;
    selectedOthSubmittedbyItems: ReportVM[] = [];


    // Approved by
    searchBarOthApprovedby: string = '';
    OthApprovedby: SearchResourceDto;
    sortedOthApprovedbyList: SearchResourceResultDto[];
    addFavouritOthApprovedbyResults: any[] = [];
    showFavouriteOthApprovedbyList: boolean = false;
    showSearchOthApprovedbyLoader: boolean = false;
    selectedOthApprovedbyItems: ReportVM[] = [];

    // Rejectedby
    searchBarOthRejectedby: string = '';
    OthRejectedby: SearchResourceDto;
    sortedOthRejectedbyList: SearchResourceResultDto[];
    addFavouritOthRejectedbyResults: any[] = [];
    showFavouriteOthRejectedbyList: boolean = false;
    showSearchOthRejectedbyLoader: boolean = false;
    selectedOthRejectedbyItems: ReportVM[] = [];

    // OthRequestorName
    searchBarOthRequestorName: string = '';
    OthRequestorName: SearchResourceDto;
    sortedOthRequestorNameList: SearchResourceResultDto[];
    addFavouritOthRequestorNameResults: any[] = [];
    showFavouriteOthRequestorNameList: boolean = false;
    showSearchOthRequestorNameLoader: boolean = false;
    selectedOthRequestorNameItems: ReportVM[] = [];

    // OthbookingId
    searchBarOthBookingId: string = '';
    othBookingId: SearchBookingDto;
    sortedOthbookingIdList: SearchResourceResultDto[];
    addFavouriteOthBookingIdResults: any[] = [];
    showFavouriteOthBookingList: boolean = false;
    showSearchOthBookingLoader: boolean = false;
    selectedOthBookingItems: ReportVM[] = [];

    // othMERABookingId
    searchBarOthMERABookingId: string = '';
    othMERABookingId: SearchMERABookingDto;
    sortedOthMERABookingIdList: SearchMERABookingResultDto[];
    addFavouriteOthMERABookingIdResults: any[] = [];
    showFavouriteOthMERABookingIdList: boolean = false;
    showSearchOthMERABookingIdLoader: boolean = false;
    selectedOthMERABookingIdItems: ReportVM[] = [];
    // End


    submittedOnStartDate: any;
    submittedOnEndDate: any;
    approvedOnStartDate: any;
    approvedOnEndDate: any;
    rejectedOnStartDate: any;
    rejectedOnEndDate: any;
    searchBar: string;
    engSearchBar: string;
    showSearchList: boolean = false;
    showEngSearchList: boolean = false;
    showSearchLoader: boolean = false;
    showEngSearchLoader: boolean = false;
    resource: SearchResourceDto;
    selectedInstance = 1;
    selectedInstanceValue = '';
    resourceListSubscription: Subscription;
    sortedResourceList: SearchResourceResultDto[];
    results;
    engResults;
    ultimateCustomerResults;
    searchUltCustBar: string;
    showSearchUltCustList: boolean = false;
    showSearchUltCustLoader: boolean = false;
    ultimateCustomer: UltimateCustomerDto;
    ultimateCustomerSearch: UltimateCustomerSearchDto;
    sortedUltCustList: UltimateCustomerDto[];
    ultimateCustomerCode: string;
    ultimateCustomerName: string;
    ultimateCustomerID: number;

    customerResults;
    searchCustomerBar: string;
    showSearchCustomerList: boolean = false;
    showSearchCustomerLoader: boolean = false;
    customer: CustomerDto;
    customerSearch: CustomerSearchDto;
    sortedCustomerList: CustomerDto[];
    customerNumber: string;
    customerName: string;
    customerId: number;

    engPartnerResults;
    searchEngPartnerBar: string;
    showSearchEngPartnerList: boolean = false;
    showSearchEngPartnerLoader: boolean = false;
    engPartner: SearchResourceResultDto;
    engPartnerSearch: SearchResourceDto;
    sortedEngPartnerList: SearchResourceResultDto[];
    selectedEngPartner: SearchResourceResultDto = new SearchResourceResultDto();
    engPartnerId: number;
    engPartnerGPN: string;
    engPartnerEmail: string;
    engPartnerName: string;

    engManagerResults;
    searchEngManagerBar: string;
    showSearchEngManagerList: boolean = false;
    showSearchEngManagerLoader: boolean = false;
    engManager: SearchResourceResultDto;
    engManagerSearch: SearchResourceDto;
    sortedEngManagerList: SearchResourceResultDto[];
    selectedEngManager: SearchResourceResultDto = new SearchResourceResultDto();
    engManagerId: number;
    engManagerGPN: string;
    engManagerEmail: string;
    engManagerName: string;

    resultsCouncellor;
    searchCouncellorBar: string;
    showSearchCouncellorList: boolean = false;
    showSearchCouncellorLoader: boolean = false;
    councellor: SearchCouncellorResultDto;
    councellorSearch: SearchCouncellorDto;
    sortedCouncellorList: SearchCouncellorResultDto[];

    selectedResource: SearchResourceResultDto = new SearchResourceResultDto();
    resourceDetails: any;
    user: any = {};
    engagementTypes: any = [];
    engagementTypesLoader: boolean = false;
    engagementSubTypes: any = [];
    engEngagementSubTypesLoader: boolean = false;
    selectedEmployeeStaus: any;
    selectedEmployeeType: any;
    selectedengagementType: any;
    weekly: boolean = true;
    includeMERABooking: boolean = false;
    includeDummyResources: boolean = false;
    includeDummyEngagement: boolean = false;
    fso: boolean = false;

    isVerifyOnEngClick: boolean = false;
    // multi
    showFavouriteEngList: boolean = false;
    showFavouriteEngManagerList: boolean = false;
    showFavouriteEngPartnerList: boolean = false;


    showFavouriteEngCustomerList: boolean = false;
    showFavouriteEngUltCustList: boolean = false;

    showFavouriteResList: boolean = false;
    isFavResONClick: boolean = true;
    isFavEngONClick: boolean = true;
    addFavouriteEngManagerResults: any[] = [];
    addFavouriteEngPartnerResults: any[] = [];
    addFavouriteEngCustomerResults: any[] = [];
    addFavouriteEngUltCustResults: any[] = [];
    addFavouriteResResults: any[] = [];
    addFavouriteEngResults: any[] = [];

    addFavouriteCounsellorResults: any[] = [];
    showFavouriteCounsellorList: boolean = false;

    isClickonFavResStart: boolean = false;
    isClickonFavEngStart: boolean = false;
    IsDataNotFound: boolean = false;

    lbl: string;
    FavoriteImageClick: boolean = false;
    IsFavEngInserted: boolean = false;
    sortedEngagementList: any[];
    engagementSearch: SearchEngagementDto;
    engagementListSubscription: Subscription;
    sortedJobList: SearchEngagementResultDto[];
    selectedJobName = '';
    JobId: number;
    EngagementTitle: string;
    engagementCode: any;
    engagementStatus: any;
    engagementServiceLine: any;
    engagementServiceCode: string;
    engagementType: any;
    today = new Date();
    todaysDate = new Date(
        this.today.getFullYear(),
        this.today.getMonth(),
        this.today.getDate(),
        0,
        0,
        0
    );
    startWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    endWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    submittedonstartWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    submittedonendWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    approvedonstartWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    approvedonendWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    rejectedonstartWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    rejectedonendWith = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    currentWeekStartDate = this.sharedService.getFirstDateOfWeek(this.todaysDate);
    weeklyModel = '';
    includeMERABookingModel = '';
    includeDummyResourcesModel = '';
    fsoModel = '';
    includeDummyEngagementModel = '';
    instances;
    defaultDateFormat: string;
    currentUserEmail: any;
    outClickCount: number = 0;
    compareFavouriteEngResults: any[] = [];
    imagePath: string = '';


    //Show Hide variables
    showResResource = false;
    showResIncludeDummyResources = false;
    showResServiceLine = false;
    showResSubServiceLine = false;
    showResCompetency = false;
    showResCountry = false;
    showResCostCenter = false;
    showResCompanyCode = false;
    showResEconomicLocation = false;
    showResOfficeLocation = false;
    showResLevel = false;
    showResGrade = false;
    showResRank = false;
    showResEmployeeStatus = false;
    showResEmployeeType = false;
    showResEmployeeDepartment = false;
    showResGDSRegionAlignment = false;
    showResCounsellor = false;
    showResAvailability = false;
    showResRegion = false;
    showResSubRegion = false;
    showResFSO = false;

    showEngEngagement = false;
    showEngIncludeDummyEngagement = false;
    showEngEngagementType = false;
    showEngEngagementSubType = false;
    showEngServiceLine = false;
    showEngSubServiceLine = false;
    showEngEngagementCompetency = false;
    showEngEngagementRegion = false;
    showEngEngagementCountry = false;
    showEngEngagementCostCenter = false;
    showEngEngagementStatus = false;
    showEngCustomerIndustry = false;
    showEngCustomerPriorityStatus = false;
    showEngEngagementManager = false;
    showEngEngagementPartner = false;
    showEngCustomer = false;
    showEngUltCust = false;

    showOthBookingCategory = false;
    showOtherBookingTypes = false;
    showOtherBookings = false;
    showOtherMERAActions = false;
    showOtherMERABookings = false;
    showOtherRequestors = false;
    showOtherRequestorModes = false;
    showOtherStatus = false;
    showOtherStatusInformation = false;
    showOtherSubmittedBy = false;
    showOtherSubmittedOn = false;
    showOtherApprovedBy = false;
    showOtherApprovedOn = false;
    showOtherRejectedBy = false;
    showOtherRejectedOn = false;
    defaultStartDate: Date | null;
    defaultEndDate: Date | null;
    showResourceTab = false;
    showEngagementTab = false;
    showOtherTab = false;
    showTabs = false;
    showWeekly = false;
    showIncludeMERABookings = false;
    isCSULoggedIn = false;
    isUpdate = false;
    loggedInResourceDetails: ResourceDetailsDto;
    isEmailRequired: boolean = false;
    showInstanceLoader: boolean = false;
    constructor(private spinner: NgxSpinnerService,
        private reportService: ReportingService,
        private orderPipe: OrderPipe,
        private modalService: BsModalService,
        private themeService: ThemeService,
        public restService: RoleConfigService,
        public individualService: IndividualService,
        public sharedService: SharedServicesService,
        public engagementService: EngagementService
    ) {
        this.weeklyModel =
            this.weekly === true ? 'weekly' : 'daily';
        this.includeDummyResourcesModel =
            this.includeDummyResources === true ? 'yes' : 'no';
        this.includeDummyEngagementModel =
            this.includeDummyEngagement === true ? 'yes' : 'no';
        this.includeMERABookingModel =
            this.includeMERABooking === true ? 'yes' : 'no';
        this.fsoModel =
            this.fso === true ? 'yes' : 'no';
    }

    ngOnInit(): void {
        this.spinner.show();
        this.user = JSON.parse(sessionStorage.getItem('resource'));
        const activeTheme = this.themeService.getActiveTheme();
        this.imagePath = activeTheme.name === 'light' ? LIGHT_PATH : DARK_PATH;
        this.selectedInstance = this.user.DefaultInstance;
        this.othBookingCategoryList = [
            { ID: 1, Text: 'Ghost' }, { ID: 2, Text: 'Confirmed' }, { ID: 3, Text: 'Unconfirmed' }
        ];
        this.getDefaultPeriodSettings();
        this.clearControls()
        this.showHideControls();

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'ID',
            textField: 'Text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 2,
            allowSearchFilter: true,
            enableCheckAll: false,

        };
        this.showInstanceLoader = true;
        this.sharedService.getUserInstances().subscribe((data) => {
            this.instances = this.sharedService.getStoredUserInstances();
            if (this.instances != undefined && this.instances.length > 0)
                this.selectedInstanceValue = this.instances.find(x => x.InstanceId == this.selectedInstance).InstanceName;
            this.showInstanceLoader = false;
        });

        if (this.user.RoleType == RoleTypeEnum.ClientServer) {
            this.isCSULoggedIn = true;
        }

        this.reportdata = new SaveReportMainDto();
        if (this.ReportMainData != undefined && this.ReportMainData.savedReportId > 0 && this.ReportMainData.savedReportFilterParameters != '') {
            this.isUpdate = true;
            this.reportdata = JSON.parse(this.ReportMainData.savedReportFilterParameters);
            this.bindData();
        }
        else {
            this.isUpdate = false;
            this.loadDropDownData();
            if (this.isCSULoggedIn && (this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE
                // || this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE
                || this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE)
            ) {
                this.GetResourceDetails();
            }
        }
        this.defaultDateFormat = this.sharedService.getDateFormat(
            this.user.DefaultDateFormat
        );
        this.currentUserEmail = this.user.Email;
        this.spinner.hide();
    }

    loadDropDownData() {
        //resource
        if (this.showResServiceLine)
            this.GetResourceServiceLine();
        if (this.showResSubServiceLine)
            this.GetResourceSubServiceLine(null);
        if (this.showResCompetency)
            this.GetResourceCompetency(null,null);
        if (this.showResCountry)
            this.GetResourceCountry(null);
        if (this.showResCostCenter)
            this.GetResourceCostCenter(null,null,null,null,null);
        if (this.showResCompanyCode)
            this.GetResourceCompanyCode(null);
        if (this.showResEconomicLocation)
            this.GetResourceEconomicLocation(null);
        // if (this.showResEmployeeDepartment)
        //     this.GetResourceDepartment(null);
        if (this.showResOfficeLocation)
            this.GetResourceOfficeLocation(null);
        if (this.showResEmployeeType)
            this.GetResourceType();
        if (this.showResEmployeeStatus)
            this.GetResourceStatus();
        if (this.showResLevel)
            this.GetResourceLevel();
        if (this.showResGrade)
            this.GetResourceGrade(null);
        if (this.showResRank)
            this.GetResourceRank();
        if (this.showResGDSRegionAlignment)
            this.GetResourceGDSRegionAlignment();
        if (this.showResRegion)
            this.GetResRegion();
        if (this.showResSubRegion)
            this.GetResSubRegion();

        //Engagement
        if (this.showEngEngagementType)
            this.GetJobCategoery();
        if (this.showEngEngagementSubType)
            this.GetJobType();
        if (this.showEngServiceLine)
            this.GetJobServiceLine();
        if (this.showEngSubServiceLine)
            this.GetJobSubServiceLine(null);
        if (this.showEngEngagementCompetency)
            this.GetJobCompetency(null,null);
        if (this.showEngEngagementRegion)
            this.GetJobSubArea();
        if (this.showEngEngagementCountry)
            this.GetJobCountry(null);
        if (this.showEngEngagementCostCenter)
            this.GetJobCostCenter(null,null,null,null,null);
        if (this.showEngEngagementStatus)
            this.GetJobStatus();
        if (this.showEngCustomerIndustry)
            this.GetCustomerIndustry();
        if (this.showEngCustomerPriorityStatus)
            this.GetCustomerPriorityStatus();

        //others
        if (this.showOtherBookingTypes)
            this.GetOtherBookingType();
        if (this.showOtherMERAActions)
            this.GetOtherMERAAction();
        if (this.showOtherRequestorModes)
            this.GetOtherMeraRequestMode();
        if (this.showOtherStatus)
            this.GetOtherMeraBookingStatus();
        if (this.showOtherStatusInformation)
            this.GetOtherMeraStatusInformation();
    }

    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    bindData() {
        if (this.showResServiceLine)
            this.GetResourceServiceLine();
        if (this.ReportMainData.reportCode != Report.ReportCode.ADOPTION_REPORTCODE && this.showResCountry)
            this.GetResourceCountry(null);
        if (this.showResEmployeeType)
            this.GetResourceType();
        if (this.showResEmployeeStatus)
            this.GetResourceStatus();
        if (this.showResLevel)
            this.GetResourceLevel();
        if (this.showResGrade)
            this.GetResourceGrade(null);
        if (this.showResRank)
            this.GetResourceRank();
        if (this.showResGDSRegionAlignment)
            this.GetResourceGDSRegionAlignment();
        if (this.showResRegion)
            this.GetResRegion();
        if (this.showResSubRegion)
            this.GetResSubRegion();

        if (this.showEngServiceLine)
            this.GetJobServiceLine();
        if (this.showEngEngagementType)
            this.GetJobCategoery();
        if (this.showEngEngagementSubType)
            this.GetJobType();
        if (this.showEngEngagementRegion)
            this.GetJobSubArea();
        if (this.showEngEngagementStatus)
            this.GetJobStatus();
        if (this.showEngCustomerIndustry)
            this.GetCustomerIndustry();
        if (this.showEngCustomerPriorityStatus)
            this.GetCustomerPriorityStatus();

        if (this.showOtherBookingTypes)
            this.GetOtherBookingType();
        if (this.showOtherMERAActions)
            this.GetOtherMERAAction();
        if (this.showOtherRequestorModes)
            this.GetOtherMeraRequestMode();
        if (this.showOtherStatus)
            this.GetOtherMeraBookingStatus();
        if (this.showOtherStatusInformation)
            this.GetOtherMeraStatusInformation();

        this.selectedTabVal = this.reportdata.tabSelected;
        this.selectedInstance = this.reportdata.instanceId;
        this.startDate = new Date(this.reportdata.startDate);
        this.endDate = new Date(this.reportdata.endDate);
        this.range.setValue({
            start: new Date(this.startDate),
            end: new Date(this.endDate),
        });
        if (this.reportdata.submittedOnStartDate != null && this.reportdata.submittedOnEndDate != null) {
            this.submittedOnStartDate = new Date(this.reportdata.submittedOnStartDate);
            this.submittedOnEndDate = new Date(this.reportdata.submittedOnEndDate);
            this.submittedOnrange.setValue({
                start: new Date(this.submittedOnStartDate),
                end: new Date(this.submittedOnEndDate),
            });
        }
        if (this.reportdata.approvedOnStartDate != null && this.reportdata.approvedOnEndDate != null) {
            this.approvedOnStartDate = new Date(this.reportdata.approvedOnStartDate);
            this.approvedOnEndDate = new Date(this.reportdata.approvedOnEndDate);
            this.approvedOnrange.setValue({
                start: new Date(this.approvedOnStartDate),
                end: new Date(this.approvedOnEndDate),
            });
        }
        if (this.reportdata.rejectedOnStartDate != null && this.reportdata.rejectedOnEndDate != null) {
            this.rejectedOnStartDate = new Date(this.reportdata.rejectedOnStartDate);
            this.rejectedOnEndDate = new Date(this.reportdata.rejectedOnEndDate);
            this.rejectedOnrange.setValue({
                start: new Date(this.rejectedOnStartDate),
                end: new Date(this.rejectedOnEndDate),
            });
        }
        this.weekly = this.reportdata.weekly;
        this.weeklyModel = this.reportdata.weekly === true ? 'weekly' : 'daily';
        this.includeMERABooking = this.reportdata.includeMERABooking;
        this.includeMERABookingModel = this.reportdata.includeMERABooking === true ? 'yes' : 'no';
        //resource
        // if (this.reportdata.gPN != undefined && this.reportdata.gPN.length > 0) {

        //     this.resourceId = this.reportdata.gPN[0].ID;
        //     this.resourceGPN = this.reportdata.gPN[0].Code;
        //     this.resourceName = this.reportdata.gPN[0].Text;
        //     this.searchBar = this.reportdata.gPN[0].Text;
        //     this.selectedResource = new SearchResourceResultDto();
        //     this.selectedResource.ResourceId = this.resourceId;
        //     this.selectedResource.ResourceName = this.resourceName;
        //     this.selectedResource.GPN = this.resourceGPN;
        // }
        // v1
        //  this.addFavouriteResResults = this.reportdata.resource;


        //ResEmployeeDepartment
        if (this.reportdata.employeeDepartment) {
            this.selectedResEmployeeDepartmentItems = this.reportdata.employeeDepartment;
            if (this.selectedResEmployeeDepartmentItems.length > 0) {
                this.loadSelectedResEmployeeDepartmentItem();
            }
        }

        //other
        if (this.reportdata.bookings) {
            this.selectedOthBookingItems = this.reportdata.bookings;
            if (this.selectedOthBookingItems.length > 0) {
                this.loadSelectedOthBookingIdItem();
            }
        }

        if (this.reportdata.mERABookings) {
            this.selectedOthMERABookingIdItems = this.reportdata.mERABookings;
            if (this.selectedOthMERABookingIdItems.length > 0) {
                this.loadSelectedOthMERABookingIdItem();
            }
        }



        if (this.reportdata.requestors) {
            this.selectedOthRequestorNameItems = this.reportdata.requestors;
            if (this.selectedOthRequestorNameItems.length > 0) {
                this.loadSelectedOthRequestorNameItem();
            }
        }

        if (this.reportdata.approvedBy) {
            this.selectedOthApprovedbyItems = this.reportdata.approvedBy;
            if (this.selectedOthApprovedbyItems.length > 0) {
                this.loadSelectedOthApprovedbyItem();
            }
        }

        if (this.reportdata.approvedBy) {
            this.selectedOthApprovedbyItems = this.reportdata.approvedBy;
            if (this.selectedOthApprovedbyItems.length > 0) {
                this.loadSelectedOthApprovedbyItem();
            }
        }

        if (this.reportdata.submittedBy) {
            this.selectedOthSubmittedbyItems = this.reportdata.submittedBy;
            if (this.selectedOthSubmittedbyItems.length > 0) {
                this.loadSelectedOthSubmittedbyItem();
            }
        }

        if (this.reportdata.rejectedBy) {
            this.selectedOthRejectedbyItems = this.reportdata.rejectedBy;
            if (this.selectedOthRejectedbyItems.length > 0) {
                this.loadSelectedOthRejectedbyItem();
            }
        }



        if (this.reportdata.resource) {
            this.selectedResItems = this.reportdata.resource;
            if (this.selectedResItems.length > 0) {
                this.loadResSelectedItem();
            }
        }

        //v2
        if (this.reportdata.councellor) {
            this.selectedCounsellorItems = this.reportdata.councellor;
            if (this.selectedCounsellorItems.length > 0) {
                this.loadCounsellorSelectedItem();
            }
        }

        //v3
        if (this.reportdata.engagement) {
            this.selectedEngItems = this.reportdata.engagement;
            if (this.selectedEngItems.length > 0) {
                this.loadEngSelectedItem();
            }
        }

        if (this.reportdata.engagementManager) {
            this.selectedEngManagerItems = this.reportdata.engagementManager;
            if (this.selectedEngManagerItems.length > 0) {
                this.loadEngManagerSelectedItem();
            }
        }
        if (this.reportdata.engagementPartner) {
            this.selectedEngPartnerItems = this.reportdata.engagementPartner;
            if (this.selectedEngPartnerItems.length > 0) {
                this.loadEngPartnerSelectedItem();
            }
        }

        if (this.reportdata.customer) {
            this.selectedEngCustomerItems = this.reportdata.customer;
            if (this.selectedEngCustomerItems.length > 0) {
                this.loadEngCustomerSelectedItem();
            }
        }


        if (this.reportdata.ultimateCustomer) {
            this.selectedEngUltCustItems = this.reportdata.ultimateCustomer;
            if (this.selectedEngUltCustItems.length > 0) {
                this.loadEngUltCustSelectedItem();
            }
        }


        this.includeDummyResources = this.reportdata.includeDummyResources;
        this.includeDummyResourcesModel = this.reportdata.includeDummyResources === true ? 'yes' : 'no';
        this.fso = this.reportdata.fso;
        this.fsoModel = this.reportdata.fso === true ? 'yes' : 'no';
        this.resServiceLineSelectedItems = this.reportService.getDummyArray(
            this.reportdata.serviceLine);

        if (this.resServiceLineSelectedItems.length > 0) {
            const selectedIds = this.resServiceLineSelectedItems.map(({ ID }) => ID);
            this.GetResourceSubServiceLine(selectedIds);
        }
        else
            this.GetResourceSubServiceLine(null);

        this.resSubServiceLineSelectedItems = this.reportService.getDummyArray(
            this.reportdata.subServiceLine);

      
                //V22

         this.resRegionSelectedItems = this.reportService.getDummyArray(
            this.reportdata.region);

        this.resSubRegionSelectedItems = this.reportService.getDummyArray(
            this.reportdata.subRegion);

        this.resManageCountrySelectedItems = this.reportService.getDummyArray(
            this.reportdata.country);

        if (this.ReportMainData.reportCode == Report.ReportCode.ADOPTION_REPORTCODE) {
            if (this.resRegionSelectedItems.length > 0) {
                const selectedIds = this.resRegionSelectedItems.map(({ ID }) => ID);
                this.GetResourceCountry(selectedIds);
            }
            else
                this.GetResourceCountry(null);
        }

        if (this.resManageCountrySelectedItems.length > 0) {
            const selectedIds = this.resManageCountrySelectedItems.map(({ ID }) => ID);
            this.GetResourceCompanyCode(selectedIds);
            this.GetResourceEconomicLocation(selectedIds);
            // this.GetResourceDepartment(selectedIds);
            this.GetResourceOfficeLocation(selectedIds);
        }
        else {
            this.GetResourceCompanyCode(null);
            this.GetResourceEconomicLocation(null);
            // this.GetResourceDepartment(null);
            this.GetResourceOfficeLocation(null);
        }

        this.resLevelSelectedItems = this.reportService.getDummyArray(
            this.reportdata.level);

        this.resGradeSelectedItems = this.reportService.getDummyArray(
            this.reportdata.grade);

        this.resRankSelectedItems = this.reportService.getDummyArrayWithCode(
            this.reportdata.rank);
         
        this.resEmployeeStatusSelectedItems = this.reportService.getDummyArray(
            this.reportdata.employeeStatus);

        this.resEmployeeTypeSelectedItems = this.reportService.getDummyArray(
            this.reportdata.employeeType);

        this.resViewCostCenterSelectedItems = this.reportService.getDummyArray(
            this.reportdata.costCentre);

        this.resCompanyCodeSelectedItems = this.reportService.getDummyArray(
            this.reportdata.companyCode);

        this.resEconomicLocationSelectedItems = this.reportService.getDummyArray(
            this.reportdata.economicLocation);

        this.resOfficeLocationSelectedItems = this.reportService.getDummyArray(
            this.reportdata.officeLocation);

        this.resCompetencySelectedItems = this.reportService.getDummyArray(
            this.reportdata.competency);

        // if (this.reportdata.counsellorName != undefined && this.reportdata.counsellorName.length > 0) {
        //     this.councellorName = this.reportdata.counsellorName[0].Text;
        //     this.searchCouncellorBar = this.reportdata.counsellorName[0].Text;
        // }

        // this.resDepartmentSelectedItems = this.reportService.getDummyArray(
        //     this.reportdata.employeeDepartment);

        this.resGDSRegionAlignmentSelectedItems = this.reportService.getDummyArray(
            this.reportdata.gdsRegionAlignment);

        this.resAvailability = this.reportdata.availability;

        //engagmeent
        // if (this.reportdata.engagementNumber != undefined && this.reportdata.engagementNumber.length > 0) {
        //     this.engSearchBar = this.reportdata.engagementNumber[0].Text;
        //     this.EngagementTitle = this.reportdata.engagementNumber[0].Text;
        //     this.JobId = this.reportdata.engagementNumber[0].ID;
        //     this.engagementCode = this.reportdata.engagementNumber[0].Code;
        // }
        this.includeDummyEngagement = this.reportdata.includeDummyEngagement;
        this.includeDummyEngagementModel = this.reportdata.includeDummyEngagement === true ? 'yes' : 'no';

        this.engEngagementTypesSelectedItems = this.reportService.getDummyArray(
            this.reportdata.engagementType);

        this.engEngagementSubTypesSelectedItems = this.reportService.getDummyArray(
            this.reportdata.engagementSubType);

        this.engServiceLineSelectedItems = this.reportService.getDummyArray(
            this.reportdata.job_ServiceLine);

        if (this.engServiceLineSelectedItems.length > 0) {
            const selectedIds = this.engServiceLineSelectedItems.map(({ ID }) => ID);
            this.GetJobSubServiceLine(selectedIds);
        }
        else
            this.GetJobSubServiceLine(null);

        this.engSubServiceLineSelectedItems = this.reportService.getDummyArray(
            this.reportdata.job_SubServiceLine);

        // if (this.engSubServiceLineSelectedItems.length > 0) {
        //     const selectedIds = this.engSubServiceLineSelectedItems.map(({ ID }) => ID);
        //     this.GetJobCompetency(selectedIds);
                   

        this.engRegionSelectedItems = this.reportService.getDummyArray(
            this.reportdata.engagementRegion);

        if (this.engRegionSelectedItems.length > 0) {
            const selectedIds = this.engRegionSelectedItems.map(({ ID }) => ID);
            this.GetJobCountry(selectedIds);
        }
        else
            this.GetJobCountry(null);

        this.engManageCountrySelectedItems = this.reportService.getDummyArray(
            this.reportdata.engagementCountry);

       

        this.engJobStatusSelectedItems = this.reportService.getDummyArray(
            this.reportdata.engagementStatus);

        this.engCompetencySelectedItems = this.reportService.getDummyArray(
            this.reportdata.job_Competency);

        this.engCostCenterSelectedItems = this.reportService.getDummyArray(
            this.reportdata.job_CostCentre);

        // if (this.reportdata.engagementManager != undefined && this.reportdata.engagementManager.length > 0) {
        //     this.searchEngManagerBar = this.reportdata.engagementManager[0].Text;
        //     this.engManagerName = this.reportdata.engagementManager[0].Text;
        //     this.engManagerGPN = this.reportdata.engagementManager[0].Code;
        //     this.engManagerId = this.reportdata.engagementManager[0].ID
        //     this.selectedEngManager = new SearchResourceResultDto();
        //     this.selectedEngManager.GPN = this.engManagerGPN;
        //     this.selectedEngManager.ResourceName = this.engManagerName;
        //     this.selectedEngManager.ResourceId = this.engManagerId;
        // }

        // if (this.reportdata.engagementPartner != undefined && this.reportdata.engagementPartner.length > 0) {
        //     this.searchEngPartnerBar = this.reportdata.engagementPartner[0].Text;
        //     this.engPartnerName = this.reportdata.engagementPartner[0].Text;
        //     this.engPartnerGPN = this.reportdata.engagementPartner[0].Code;
        //     this.engPartnerId = this.reportdata.engagementPartner[0].ID;
        //     this.selectedEngPartner = new SearchResourceResultDto();
        //     this.selectedEngPartner.GPN = this.engPartnerGPN;
        //     this.selectedEngPartner.ResourceName = this.engPartnerName;
        //     this.selectedEngPartner.ResourceId = this.engPartnerId;
        // }

        // if (this.reportdata.customer != undefined && this.reportdata.customer.length > 0) {
        //     this.customerName = this.reportdata.customer[0].Text;
        //     this.customerNumber = this.reportdata.customer[0].Code;
        //     this.searchCustomerBar = this.reportdata.customer[0].Text;
        //     this.customerId = this.reportdata.customer[0].ID;
        // }

        this.engCustomerIndustrySelectedItems = this.reportService.getDummyArray(
            this.reportdata.customerIndustry);

        this.engCustomerPriorityStatusSelectedItems = this.reportService.getDummyArray(
            this.reportdata.customerPriorityStatus);

        // if (this.reportdata.ultimateCustomer != undefined && this.reportdata.ultimateCustomer.length > 0) {
        //     this.ultimateCustomerName = this.reportdata.ultimateCustomer[0].Text;
        //     this.ultimateCustomerCode = this.reportdata.ultimateCustomer[0].Code;
        //     this.ultimateCustomerID = this.reportdata.ultimateCustomer[0].ID;
        //     this.searchUltCustBar = this.reportdata.ultimateCustomer[0].Text
        // }

        //Other
        this.othBookingCategorySelectedItems = this.reportService.getDummyArray(
            this.reportdata.bookingCategory);

        this.othBookingTypeSelectedItems = this.reportService.getDummyArray(
            this.reportdata.bookingTypes);

        this.othMERAActionSelectedItems = this.reportService.getDummyArray(
            this.reportdata.mERAActions);

        this.othMeraBookingStatusSelectedItems = this.reportService.getDummyArray(
            this.reportdata.status);

        this.othMeraStatusInformationSelectedItems = this.reportService.getDummyArray(
            this.reportdata.statusInformation);

        this.othMeraRequestModeSelectedItems = this.reportService.getDummyArray(
            this.reportdata.requestorModes);

            // for Resource V22
            this.selectedResSLIds = null;
            this.selectedResSSLIds = null;
            this.selectedResCompetencyCode = null;
            this.selectedResSubAreaCode = null;
            this.selectedResCountryCode = null;
            // debugger;
                if (this.resServiceLineSelectedItems.map(({ ID }) => ID).length > 0){
                    this.selectedResSLIds = this.resServiceLineSelectedItems.map(({ ID }) => ID);
                  }
                  
                if (this.resSubServiceLineSelectedItems.map(({ ID }) => ID).length > 0){
                    this.selectedResSSLIds = this.resSubServiceLineSelectedItems.map(({ ID }) => ID);
                }
    
                if (this.resCompetencySelectedItems.length > 0) {
                    this.selectedResCompetencyCode  = this.resCompetencySelectedItems.map(({ ID }) => ID);
                }
    
              if (this.resRegionSelectedItems.length > 0) {
                    this.selectedResSubAreaCode  = this.resRegionSelectedItems.map(({ ID }) => ID);
                }
    
                if (this.resManageCountrySelectedItems.length > 0) {
                   this.selectedResCountryCode = this.resManageCountrySelectedItems.map(({ ID }) => ID);
                }
    
                this.GetResourceCompetency(this.selectedResSLIds,this.selectedResSSLIds);
                this.GetResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
            
                // V22 
                this.selectedEngSLIds = null;
                this.selectedEngSSLIds = null;
                this.selectedEngCompetencyCode = null;
                this.selectedEngSubAreaCode  = null;
                this.selectedEngCountryCode = null;
                    // debugger;
                    if (this.engServiceLineSelectedItems.length > 0) {
                                this.selectedEngSLIds  = this.engServiceLineSelectedItems.map(({ ID }) => ID);
                        }
                    
                    if (this.engSubServiceLineSelectedItems.length > 0) {
                                this.selectedEngSSLIds  = this.engSubServiceLineSelectedItems.map(({ ID }) => ID);
                        }


                    if (this.engCompetencySelectedItems.length > 0) {
                            this.selectedEngCompetencyCode  = this.engCompetencySelectedItems.map(({ ID }) => ID);
                        }

                    if (this.engRegionSelectedItems.length > 0) {
                            this.selectedEngSubAreaCode  = this.engRegionSelectedItems.map(({ ID }) => ID);
                        }

                    if (this.engManageCountrySelectedItems.length > 0) {
                        this.selectedEngCountryCode  = this.engManageCountrySelectedItems.map(({ ID }) => ID);
                    }

                    this.GetJobCompetency(this.selectedEngSLIds,this.selectedEngSSLIds);
                    this.GetJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);


    }

    clearControls() {
        this.selectedInstance = this.user.DefaultInstance;
        if (this.instances != undefined && this.instances.length > 0)
            this.selectedInstanceValue = this.instances.find(x => x.InstanceId == this.selectedInstance).InstanceName;
        this.range.setValue({
            start: this.defaultStartDate
                ? moment(this.defaultStartDate)
                : null,
            end: this.defaultEndDate
                ? moment(this.defaultEndDate)
                : null,
        });
        this.startDate = this.defaultStartDate;
        this.endDate = this.defaultEndDate;
        this.submittedOnrange.setValue({
            start: null,
            end: null,
        });
        this.submittedOnStartDate = null;
        this.submittedOnEndDate = null;
        this.approvedOnrange.setValue({
            start: null,
            end: null,
        });
        this.approvedOnStartDate = null;
        this.approvedOnEndDate = null;
        this.rejectedOnrange.setValue({
            start: null,
            end: null,
        });
        this.rejectedOnStartDate = null;
        this.rejectedOnEndDate = null;
        this.weekly = true;
        this.weeklyModel = 'weekly';

        this.includeMERABookingModel = 'yes';
        this.includeMERABooking = true;
        switch (this.ReportMainData.reportCode) {
            case Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE:
            case Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE:
                if (this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE)
                    this.selectedTabVal = "Engagement";
                else
                    this.selectedTabVal = 'Resource';
                this.showResourceTab = true;
                this.showEngagementTab = true;
                this.showOtherTab = true;
                this.showTabs = true;
                this.showWeekly = true;
                this.showIncludeMERABookings = true;
                break;
            case Report.ReportCode.AUDITTRAIL_REPORTCODE:
                this.selectedTabVal = 'Resource';
                this.showResourceTab = true;
                this.showEngagementTab = true;
                this.showOtherTab = true;
                this.showTabs = true;
                this.showWeekly = false;
                this.showIncludeMERABookings = false;
                break;
            case Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE:
                this.selectedTabVal = 'Resource'
                this.showResourceTab = true;
                this.showEngagementTab = false;
                this.showOtherTab = false;
                this.showTabs = false;
                this.showWeekly = true;
                this.showIncludeMERABookings = true;
                break;
            case Report.ReportCode.ADOPTION_REPORTCODE:
                this.selectedTabVal = 'Resource'
                this.showResourceTab = true;
                this.showEngagementTab = false;
                this.showOtherTab = false;
                this.showTabs = false;
                this.showWeekly = false;
                this.showIncludeMERABookings = false;
                break;
        }

        //resource
        this.resetfilterResourceSearchBar();
        this.includeDummyResources = 
            this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE;
        this.includeDummyResourcesModel = 
            this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE
            ? 'yes' : 'no';
       
        this.fso = false;
        this.fsoModel = 'no';
        this.resServiceLineSelectedItems = [];
        this.resManageCountrySelectedItems = [];
        this.resEmployeeTypeSelectedItems = [];
        this.resEmployeeStatusSelectedItems = [];
        this.resLevelSelectedItems = [];
        this.resGradeSelectedItems = [];
        this.resRankSelectedItems = [];
        this.resGDSRegionAlignmentSelectedItems = [];
        this.resSubServiceLineSelectedItems = [];
        this.resCompetencySelectedItems = [];
        this.resViewCostCenterSelectedItems = [];
        this.resCompanyCodeSelectedItems = [];
        this.resEconomicLocationSelectedItems = [];
        this.resOfficeLocationSelectedItems = [];
        this.resDepartmentSelectedItems = [];

        this.resetfilterCouncellorSearchBar();
        this.resAvailability = 0;
        this.resRegionSelectedItems = []; //Region
        this.resSubRegionSelectedItems = []; //Sub Region


        //engagement
        this.resetfilterEngagementSearchBar();
        // this.includeDummyEngagement = false;
        // this.includeDummyEngagementModel = 'no';
        this.includeDummyEngagement = true;
        this.includeDummyEngagementModel = 'yes';

        this.engServiceLineSelectedItems = [];
        this.engRegionSelectedItems = []; //Sub Area
        this.engEngagementTypesSelectedItems = []; // Job category
        this.engEngagementSubTypesSelectedItems = []; // Job type
        this.engJobStatusSelectedItems = [];
        this.engCustomerIndustrySelectedItems = [];
        this.engCustomerPriorityStatusSelectedItems = [];
        this.engSubServiceLineSelectedItems = [];
        this.engCompetencySelectedItems = [];
        this.engManageCountrySelectedItems = [];
        this.engCostCenterSelectedItems = [];
        this.resetfilterEngManagerSearchBar();
        this.resetfilterEngPartnerSearchBar();
        this.resetfilterSearchCustomerSearchBar();
        this.resetfilterSearchUltCustSearchBar();
        this.resetfiltersearchBarResEmployeeDepartment();
        //Other
        this.othBookingCategorySelectedItems = [];
        this.othBookingTypeSelectedItems = [];
        this.othMeraRequestModeSelectedItems = [];
        this.othMERAActionSelectedItems = [];
        this.othMeraBookingStatusSelectedItems = [];
        this.othMeraStatusInformationSelectedItems = [];
        this.resetfiltersearchBarOthBookingId();
        this.resetfiltersearchBarOthMERABookingId();
        this.resetfiltersearchBarOthRequestorName();
        this.resetfiltersearchBarOthSubmittedby();
        this.resetfiltersearchBarOthApprovedby();
        this.resetfiltersearchBarOthRejectedby();

        this.selectedResItems = [];
        this.selectedResEmployeeDepartmentItems = [];
        this.selectedCounsellorItems = [];
        this.selectedEngItems = [];
        this.selectedEngManagerItems = [];
        this.selectedEngPartnerItems = [];
        this.selectedEngCustomerItems = [];
        this.selectedEngUltCustItems = [];
        this.selectedOthBookingItems = [];
        this.selectedOthMERABookingIdItems = [];
        this.selectedOthRequestorNameItems = [];
        this.selectedOthSubmittedbyItems = [];
        this.selectedOthRejectedbyItems = [];
        this.selectedOthApprovedbyItems = [];

        this.closeMessage();
        this.closePopupMessage();
    }

    clearSelection() {
        this.spinner.show();
        this.clearControls();
        this.ReportMainData.savedReportId = 0;
        this.ReportMainData.savedReportName = '';
        this.ReportMainData.savedReportFilterParameters = '';
        this.isUpdate = false;
        this.spinner.hide();
    }

    downLoadFile(response: any, fileName?: string) {
        const blob = new Blob([response.body], { type: response.headers.get('content-type') });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        a.click();
    }

    generateReport() {
        this.messageTitle = '';
        this.messageBody = "";
        let isDataExists = false;
        let isResponseReceived = false;
        this.messageBody = '';
        this.messageTitle = '';
        let reportExcelFileName = '';
        if (this.startDate == undefined) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please select date range.";
            this.onScroll();
            return;
        }
        if (this.endDate == undefined) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please select date range.";
            this.onScroll();
            return;
        }
        if (this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE
            && this.resAvailability != null && this.resAvailability != undefined
            && (this.resAvailability < 0 || this.resAvailability > 100)) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please enter Availability (%) between 0 to 100.";
            this.onScroll();
            return;
        }
        this.spinner.show();

        let includeInQueue: boolean = true;
        // let durationInDays = this.calculateDaysBetweenDates(this.startDate, this.endDate);
        // if (durationInDays > 90)
        //     includeInQueue = true;

        let reportDto = new GenerateReportMainDto();
        reportDto.Instance = this.selectedInstanceValue;
        reportDto.StartDate = this.startDate;
        reportDto.EndDate = this.endDate;
        reportDto.StartDate?.setMinutes(
            reportDto.StartDate?.getMinutes() -
            reportDto.StartDate?.getTimezoneOffset()
        );
        reportDto.EndDate?.setMinutes(
            reportDto.EndDate?.getMinutes() -
            reportDto.EndDate?.getTimezoneOffset()
        );
      
        // resource
        reportDto.Resources = [];
        if (this.selectedResItems != undefined && this.selectedResItems.length > 0) {
            let data = [];
            this.selectedResItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text, instanceId: this.selectedInstance });
            });
            reportDto.Resources = data;
        }
        if (this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE
            || this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE
        ) {
            reportDto.Weekly = this.weekly;
            reportDto.IncludeMERABooking = this.includeMERABooking;
            reportDto.IncludeDummyResources = this.includeDummyResources;
            reportDto.IncludeDummyEngagement = this.includeDummyEngagement;
        }
        if (this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE) {
            reportDto.Weekly = this.weekly;
            reportDto.IncludeMERABooking = this.includeMERABooking;
            reportDto.ResourceAvailability = (this.resAvailability == null || this.resAvailability == undefined) ? 0 : this.resAvailability;
        }
        if (this.ReportMainData.reportCode == Report.ReportCode.ADOPTION_REPORTCODE) {
            reportDto.ResourceFSO = this.fso;
        }
        reportDto.ResourceServiceLine = this.resServiceLineSelectedItems;
        reportDto.ResourceSubServiceLine = this.resSubServiceLineSelectedItems;
        reportDto.ResourceCompetency = this.resCompetencySelectedItems;
        reportDto.ResourceCountry = this.resManageCountrySelectedItems;
        reportDto.ResourceCostCenter = this.resViewCostCenterSelectedItems;
        reportDto.ResourceCompanyCode = this.resCompanyCodeSelectedItems;
        reportDto.ResourceEconomicLocation = this.resEconomicLocationSelectedItems;
        reportDto.ResourceOfficeLocation = this.resOfficeLocationSelectedItems;
        reportDto.ResourceLevel = this.resLevelSelectedItems;
        reportDto.ResourceGrade = this.resGradeSelectedItems;
        reportDto.ResourceRank = this.resRankSelectedItems;
        reportDto.ResourceEmployeeStatus = this.resEmployeeStatusSelectedItems;
        reportDto.ResourceEmployeeType = this.resEmployeeTypeSelectedItems;
        // reportDto.ResourceEmployeeDepartment = this.resDepartmentSelectedItems;

        // ResEmployeeDepartment
        reportDto.ResourceEmployeeDepartment = [];
        if (this.selectedResEmployeeDepartmentItems != undefined && this.selectedResEmployeeDepartmentItems.length > 0) {
            let data = [];
            this.selectedResEmployeeDepartmentItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text });
            });
            reportDto.ResourceEmployeeDepartment = data;
        }

        reportDto.ResourceGDSRegionAlignment = this.resGDSRegionAlignmentSelectedItems;
        // councellor
        reportDto.ResourceCounsellors = [];
        if (this.selectedCounsellorItems != undefined && this.selectedCounsellorItems.length > 0) {
            let data = [];
            this.selectedCounsellorItems.forEach(aa => {
                data.push({ ID: 0, Text: aa.Text });
            });
            reportDto.ResourceCounsellors = data;
        }
        reportDto.ResourceRegion = this.resRegionSelectedItems;
        reportDto.ResourceSubRegion = this.resSubRegionSelectedItems;

        // Engagement
        reportDto.Engagements = [];
        if (this.selectedEngItems != undefined && this.selectedEngItems.length > 0) {
            let data = [];
            this.selectedEngItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text, instanceId: this.selectedInstance });
            });
            reportDto.Engagements = data;
        }
        reportDto.EngagementType = this.engEngagementTypesSelectedItems;
        reportDto.EngagementSubType = this.engEngagementSubTypesSelectedItems;
        reportDto.EngagementServiceLine = this.engServiceLineSelectedItems;
        reportDto.EngagementSubServiceLine = this.engSubServiceLineSelectedItems;
        reportDto.EngagementCompetency = this.engCompetencySelectedItems;
        reportDto.EngagementRegion = this.engRegionSelectedItems;
        reportDto.EngagementCountry = this.engManageCountrySelectedItems;
        reportDto.EngagementCostCenter = this.engCostCenterSelectedItems;
        reportDto.EngagementStatus = this.engJobStatusSelectedItems;
        reportDto.EngagementCustomerIndustry = this.engCustomerIndustrySelectedItems;
        reportDto.EngagementCustomerPriorityStatus = this.engCustomerPriorityStatusSelectedItems;
        reportDto.EngagementManagers = [];
        if (this.selectedEngManagerItems != undefined && this.selectedEngManagerItems.length > 0) {
            let data = [];
            this.selectedEngManagerItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text, instanceId: this.selectedInstance });
            });
            reportDto.EngagementManagers = data;
        }
        reportDto.EngagementPartners = [];
        if (this.selectedEngPartnerItems != undefined && this.selectedEngPartnerItems.length > 0) {
            let data = [];
            this.selectedEngPartnerItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text, instanceId: this.selectedInstance });
            });
            reportDto.EngagementPartners = data;
        }
        reportDto.EngagementCustomers = [];
        if (this.selectedEngCustomerItems != undefined && this.selectedEngCustomerItems.length > 0) {
            let data = [];
            this.selectedEngCustomerItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text, instanceId: this.selectedInstance });
            });
            reportDto.EngagementCustomers = data;
        }
        reportDto.EngagementUltimateCustomers = [];
        if (this.selectedEngUltCustItems != undefined && this.selectedEngUltCustItems.length > 0) {
            let data = [];
            this.selectedEngUltCustItems.forEach(aa => {
                data.push({ ID: aa.ID, Text: aa.Text });
            });
            reportDto.EngagementUltimateCustomers = data;
        }
        //Other
        reportDto.OtherBookingCategories = this.othBookingCategorySelectedItems;
        if (this.ReportMainData.reportCode == Report.ReportCode.AUDITTRAIL_REPORTCODE) {
            reportDto.OtherBookingTypes = this.othBookingTypeSelectedItems;
            reportDto.OtherMERAActions = this.othMERAActionSelectedItems;
            reportDto.OtherRequestorModes = this.othMeraRequestModeSelectedItems;
            reportDto.OtherStatus = this.othMeraBookingStatusSelectedItems;
            reportDto.OtherStatusInformation = this.othMeraStatusInformationSelectedItems;
            if (this.submittedOnStartDate)
                reportDto.OtherSubmittedOnStartDate = this.submittedOnStartDate;
            if (this.submittedOnEndDate)
                reportDto.OtherSubmittedOnEndDate = this.submittedOnEndDate;
            if (reportDto.OtherSubmittedOnStartDate) {
                reportDto.OtherSubmittedOnStartDate?.setMinutes(
                    reportDto.OtherSubmittedOnStartDate?.getMinutes() -
                    reportDto.OtherSubmittedOnStartDate?.getTimezoneOffset()
                );
            }
            if (reportDto.OtherSubmittedOnEndDate) {
                reportDto.OtherSubmittedOnEndDate?.setMinutes(
                    reportDto.OtherSubmittedOnEndDate?.getMinutes() -
                    reportDto.OtherSubmittedOnEndDate?.getTimezoneOffset()
                );
            }
            if (this.approvedOnStartDate)
                reportDto.OtherApprovedOnStartDate = this.approvedOnStartDate;
            if (this.approvedOnEndDate)
                reportDto.OtherApprovedOnEndDate = this.approvedOnEndDate;
            if (reportDto.OtherApprovedOnStartDate) {
                reportDto.OtherApprovedOnStartDate?.setMinutes(
                    reportDto.OtherApprovedOnStartDate?.getMinutes() -
                    reportDto.OtherApprovedOnStartDate?.getTimezoneOffset()
                );
            }
            if (reportDto.OtherApprovedOnEndDate) {
                reportDto.OtherApprovedOnEndDate?.setMinutes(
                    reportDto.OtherApprovedOnEndDate?.getMinutes() -
                    reportDto.OtherApprovedOnEndDate?.getTimezoneOffset()
                );
            }
            if (this.rejectedOnStartDate)
                reportDto.OtherRejectedOnStartDate = this.rejectedOnStartDate;
            if (this.rejectedOnEndDate)
                reportDto.OtherRejectedOnEndDate = this.rejectedOnEndDate;
            if (reportDto.OtherRejectedOnStartDate) {
                reportDto.OtherRejectedOnStartDate?.setMinutes(
                    reportDto.OtherRejectedOnStartDate?.getMinutes() -
                    reportDto.OtherRejectedOnStartDate?.getTimezoneOffset()
                );
            }
            if (reportDto.OtherRejectedOnEndDate) {
                reportDto.OtherRejectedOnEndDate?.setMinutes(
                    reportDto.OtherRejectedOnEndDate?.getMinutes() -
                    reportDto.OtherRejectedOnEndDate?.getTimezoneOffset()
                );
            }
            reportDto.OtherBookingTypes = [];
            if (this.selectedOthBookingItems != undefined && this.selectedOthBookingItems.length > 0) {
                let data = [];
                this.selectedOthBookingItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text });
                });
                reportDto.OtherBookingTypes = data;
            }

            reportDto.OtherMERABookings = [];
            if (this.selectedOthMERABookingIdItems != undefined && this.selectedOthMERABookingIdItems.length > 0) {
                let data = [];
                this.selectedOthMERABookingIdItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text });
                });
                reportDto.OtherMERABookings = data;
            }

            reportDto.OtherRequestors = [];
            if (this.selectedOthRequestorNameItems != undefined && this.selectedOthRequestorNameItems.length > 0) {
                let data = [];
                this.selectedOthRequestorNameItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text });
                });
                reportDto.OtherRequestors = data;
            }


            reportDto.OtherApprovedBy = [];
            if (this.selectedOthApprovedbyItems != undefined && this.selectedOthApprovedbyItems.length > 0) {
                let data = [];
                this.selectedOthApprovedbyItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text });
                });
                reportDto.OtherApprovedBy = data;
            }

            reportDto.OtherSubmittedBy = [];
            if (this.selectedOthSubmittedbyItems != undefined && this.selectedOthSubmittedbyItems.length > 0) {
                let data = [];
                this.selectedOthSubmittedbyItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text });
                });
                reportDto.OtherSubmittedBy = data;
            }

            reportDto.OtherRejectedBy = [];
            if (this.selectedOthRejectedbyItems != undefined && this.selectedOthRejectedbyItems.length > 0) {
                let data = [];
                this.selectedOthRejectedbyItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text });
                });
                reportDto.OtherRejectedBy = data;
            }
        }
        reportDto.isEmailRequired = this.isEmailRequired;

        const paramString: string = JSON.stringify(reportDto);
        let generateReportData = new GenerateReportDto;
        generateReportData.ReportId = this.ReportMainData.reportId;
        generateReportData.SavedReportId = this.ReportMainData.savedReportId;
        generateReportData.ReportName = this.ReportMainData.reportName;
        generateReportData.ReportCode = this.ReportMainData.reportCode;
        generateReportData.ReportFilters = paramString;
        generateReportData.defaultDateFormat = this.defaultDateFormat;
        switch (this.ReportMainData.reportCode) {
            case Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.BOOKEDTIMEBYRESOURCE_FILENAME;
                break;
            case Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.BOOKEDTIMEBYENGAGEMENT_FILENAME
                break;
            case Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.AVAILABILITYBYFORECASTEDHOURS_FILENAME;
                break;
            case Report.ReportCode.AUDITTRAIL_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.AUDITTRAIL_FILENAME;
                break;
            case Report.ReportCode.ADOPTION_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.ADOPTION_FILENAME;
                break;
        }
        let param = { base64string: btoa(unescape(encodeURIComponent(JSON.stringify(generateReportData)))) };
        let generateReportInputDto = new GenerateReportInputDto;
        generateReportInputDto.base64string = param.base64string;
        if (!includeInQueue) {
            this.reportService.GenerateReport(generateReportInputDto).subscribe({
                next: (respData: any) => {
                    if (respData) {
                        if (respData?.body?.type && respData?.body?.type != 'application/json' && respData?.body?.type != 'text/plain') {
                            isDataExists = true;
                            const datepipe: DatePipe = new DatePipe('en-US')
                            let formattedDate = datepipe.transform(new Date(), 'ddMMyyyyHHmmss')
                            this.downLoadFile(respData, reportExcelFileName + '_' + formattedDate);
                            this.spinner.hide()
                        }
                    }
                    isResponseReceived = true;
                },
                error: (err: any) => {
                    this.messageTitle = 'Failed';
                    this.messageBody = "Unexpected server error. Please try again.";
                    this.onScroll();
                },
                complete: () => {
                    if (isResponseReceived) {
                        if (!isDataExists) {
                            this.messageTitle = 'Information';
                            this.messageBody = "No data exists.";
                            this.onScroll();
                            this.spinner.hide()
                        }
                    }
                    else {
                        this.messageTitle = 'Failed';
                        this.messageBody = "Unexpected server error. Please try again.";
                        this.onScroll();
                        this.spinner.hide()
                    }
                }
            });
        }
        else {
            this.reportService.GenerateReportQueue(generateReportInputDto).subscribe({
                next: (respData: any) => {
                    if (respData.success) {
                        this.messageTitle = 'Success';
                        this.messageBody = "Submitted successfully. Navigate to 'Queued Reports', download button will be available once Status will be updated to 'Completed'.";
                        this.onScroll();
                    }
                    else {
                        this.messageTitle = 'Failed';
                        this.messageBody = "Unexpected server error. Please try again.";
                        this.onScroll();
                    }
                    isResponseReceived = true;
                },
                error: (err: any) => {
                    this.messageTitle = 'Failed';
                    this.messageBody = "Unexpected server error. Please try again.";
                    this.onScroll();
                },
                complete: () => {
                    if (!isResponseReceived) {
                        this.messageTitle = 'Failed';
                        this.messageBody = "Unexpected server error. Please try again.";
                        this.onScroll();
                    }
                    this.spinner.hide()
                }
            });
        }
    }
    SaveFilter() {
        this.saveData(this.ReportMainData.savedReportId > 0 ? true : false);
    }
    saveData(isUpdate: boolean) {
        this.popupMessageBody = '';
        this.popupMessageTitle = '';
        this.messageBody = '';
        this.messageTitle = '';
        if (this.startDate == undefined) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please select date range.";
            this.onScroll();
            return;
        }
        if (this.endDate == undefined) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please select date range.";
            this.onScroll();
            return;
        }
        if (this.savedReportName.trim() == '') {
            this.popupMessageTitle = 'Failed';
            this.popupMessageBody = "Please enter Report Name.";
            
            return;
        }
        if (this.savedReportName.trim() != '' && this.savedReportName.trim().length > 100) {
            this.popupMessageTitle = 'Failed';
            this.popupMessageBody = "Please enter Report Name less than or equal to 100 characters.";
            return;
        }
        if (this.savedReportComments.trim() != '' && this.savedReportComments.trim().length > 250) {
            this.popupMessageTitle = 'Failed';
            this.popupMessageBody = "Please enter comments less than or equal to 250 characters.";
            return;
        }
        if (this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE
            && this.resAvailability != null && this.resAvailability != undefined
            && (this.resAvailability < 0 || this.resAvailability > 100)) {
            this.popupMessageTitle = 'Failed';
            this.popupMessageBody = "Please enter Availability (%) between 0 to 100.";
            return;
        }
        if (isUpdate && this.ReportMainData.savedReportName != this.savedReportName.trim()) {
            this.popupMessageTitle = 'Failed';
            this.popupMessageBody = "Please do not change Report Name to overwirte existing saved filter.";
            return;
        }
        this.spinner.show();
        let reportDto = new SaveReportMainDto();
        reportDto.instanceId = this.selectedInstance;
        reportDto.startDate = this.startDate;
        reportDto.endDate = this.endDate;
        reportDto.startDate?.setMinutes(
            reportDto.startDate?.getMinutes() -
            reportDto.startDate?.getTimezoneOffset()
        );
        reportDto.endDate?.setMinutes(
            reportDto.endDate?.getMinutes() -
            reportDto.endDate?.getTimezoneOffset()
        );
        reportDto.weekly = this.weekly;
        reportDto.includeMERABooking = this.includeMERABooking;

        reportDto.tabSelected = this.selectedTabVal;

        // resource
        // if (this.resourceId > 0)
        //     reportDto.gPN = [{ ID: this.resourceId, Text: this.resourceName, Code: this.resourceGPN }];
        if (this.selectedResItems) {
            if (this.selectedResItems.length > 0) {
                let data = [];
                this.selectedResItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                });
                reportDto.resource = data;
            }
        }

        reportDto.serviceLine = this.resServiceLineSelectedItems;
        reportDto.subServiceLine = this.resSubServiceLineSelectedItems;
        reportDto.competency = this.resCompetencySelectedItems;
        reportDto.costCentre = this.resViewCostCenterSelectedItems;
        reportDto.includeDummyResources = this.includeDummyResources;
        reportDto.fso = this.fso;
        reportDto.country = this.resManageCountrySelectedItems;
        reportDto.level = this.resLevelSelectedItems;
        reportDto.grade = this.resGradeSelectedItems;
        reportDto.rank = this.resRankSelectedItems;
        reportDto.employeeStatus = this.resEmployeeStatusSelectedItems;
        reportDto.employeeType = this.resEmployeeTypeSelectedItems;
        reportDto.companyCode = this.resCompanyCodeSelectedItems;
        reportDto.economicLocation = this.resEconomicLocationSelectedItems;
        reportDto.officeLocation = this.resOfficeLocationSelectedItems;
        // reportDto.employeeDepartment = this.resDepartmentSelectedItems;

        if (this.selectedResEmployeeDepartmentItems) {
            if (this.selectedResEmployeeDepartmentItems.length > 0) {
                let data = [];
                this.selectedResEmployeeDepartmentItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Code });
                });
                reportDto.employeeDepartment = data;
            }
        }

        reportDto.availability = (this.resAvailability == null || this.resAvailability == undefined) ? 0 : this.resAvailability;
        // if (this.councellorName != undefined && this.councellorName != '') {
        //     reportDto.counsellorName = [{ ID: 1, Text: this.councellorName, Code: this.councellorName }];
        // }
        // councellor
        if (this.selectedCounsellorItems) {
            if (this.selectedCounsellorItems.length > 0) {
                let data = [];
                this.selectedCounsellorItems.forEach(aa => {
                    data.push({ ID: 0, Text: aa.Text, Code: aa.Text });
                });
                reportDto.councellor = data;
            }
        }
        reportDto.gdsRegionAlignment = this.resGDSRegionAlignmentSelectedItems;
        reportDto.region = this.resRegionSelectedItems;
        reportDto.subRegion = this.resSubRegionSelectedItems;
        // Engagement

        if (this.selectedEngItems) {
            if (this.selectedEngItems.length > 0) {
                let data = [];
                this.selectedEngItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                });
                reportDto.engagement = data;
            }
        }
        // if (this.JobId > 0)
        //     reportDto.engagementNumber = [{ ID: this.JobId, Text: this.EngagementTitle, Code: this.engagementCode }];
        reportDto.includeDummyEngagement = this.includeDummyEngagement;
        reportDto.engagementType = this.engEngagementTypesSelectedItems;
        reportDto.engagementSubType = this.engEngagementSubTypesSelectedItems;
        reportDto.job_ServiceLine = this.engServiceLineSelectedItems;
        reportDto.job_SubServiceLine = this.engSubServiceLineSelectedItems;
        reportDto.engagementRegion = this.engRegionSelectedItems;
        reportDto.engagementCountry = this.engManageCountrySelectedItems;
        reportDto.engagementStatus = this.engJobStatusSelectedItems;

        reportDto.job_Competency = this.engCompetencySelectedItems;
        reportDto.job_CostCentre = this.engCostCenterSelectedItems;

        // if (this.engManagerId > 0) {
        //     reportDto.engagementManager = [{ ID: this.engManagerId, Text: this.engManagerName, Code: this.engManagerGPN }];
        // }

        if (this.selectedEngManagerItems) {
            if (this.selectedEngManagerItems.length > 0) {
                let data = [];
                this.selectedEngManagerItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                });
                reportDto.engagementManager = data;
            }
        }
        // if (this.engPartnerId > 0) {
        //     reportDto.engagementPartner = [{ ID: this.engPartnerId, Text: this.engPartnerName, Code: this.engPartnerGPN }];
        // }


        if (this.selectedEngPartnerItems) {
            if (this.selectedEngPartnerItems.length > 0) {
                let data = [];
                this.selectedEngPartnerItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                });
                reportDto.engagementPartner = data;
            }
        }

        reportDto.customerIndustry = this.engCustomerIndustrySelectedItems;
        reportDto.customerPriorityStatus = this.engCustomerPriorityStatusSelectedItems;

        // if (this.customerNumber != undefined && this.customerName != undefined
        //     && this.customerNumber != '' && this.customerName != '') {
        //     reportDto.customer = [{ ID: this.customerId, Text: this.customerName, Code: this.customerNumber }];
        // }
        if (this.selectedEngCustomerItems) {
            if (this.selectedEngCustomerItems.length > 0) {
                let data = [];
                this.selectedEngCustomerItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                });
                reportDto.customer = data;
            }
        }
        // if (this.ultimateCustomerID > 0) {
        //     reportDto.ultimateCustomer = [{ ID: this.ultimateCustomerID, Text: this.ultimateCustomerName, Code: this.ultimateCustomerCode }];
        // }

        if (this.selectedEngUltCustItems) {
            if (this.selectedEngUltCustItems.length > 0) {
                let data = [];
                this.selectedEngUltCustItems.forEach(aa => {
                    data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                });
                reportDto.ultimateCustomer = data;
            }
        }

        //Other
        reportDto.bookingCategory = this.othBookingCategorySelectedItems;
        if (this.ReportMainData.reportCode == Report.ReportCode.AUDITTRAIL_REPORTCODE) {
            reportDto.bookingTypes = this.othBookingTypeSelectedItems;
            reportDto.mERAActions = this.othMERAActionSelectedItems;
            reportDto.requestorModes = this.othMeraRequestModeSelectedItems;
            reportDto.status = this.othMeraBookingStatusSelectedItems;
            reportDto.statusInformation = this.othMeraStatusInformationSelectedItems;
            reportDto.submittedOnStartDate = this.submittedOnStartDate;
            reportDto.submittedOnEndDate = this.submittedOnEndDate;
            if (reportDto.submittedOnStartDate) {
                reportDto.submittedOnStartDate?.setMinutes(
                    reportDto.submittedOnStartDate?.getMinutes() -
                    reportDto.submittedOnStartDate?.getTimezoneOffset()
                );
            }
            if (reportDto.submittedOnEndDate) {
                reportDto.submittedOnEndDate?.setMinutes(
                    reportDto.submittedOnEndDate?.getMinutes() -
                    reportDto.submittedOnEndDate?.getTimezoneOffset()
                );
            }
            reportDto.approvedOnStartDate = this.approvedOnStartDate;
            reportDto.approvedOnEndDate = this.approvedOnEndDate;
            if (reportDto.approvedOnStartDate) {
                reportDto.approvedOnStartDate?.setMinutes(
                    reportDto.approvedOnStartDate?.getMinutes() -
                    reportDto.approvedOnStartDate?.getTimezoneOffset()
                );
            }
            if (reportDto.approvedOnEndDate) {
                reportDto.approvedOnEndDate?.setMinutes(
                    reportDto.approvedOnEndDate?.getMinutes() -
                    reportDto.approvedOnEndDate?.getTimezoneOffset()
                );
            }
            reportDto.rejectedOnStartDate = this.rejectedOnStartDate;
            reportDto.rejectedOnEndDate = this.rejectedOnEndDate;
            if (reportDto.rejectedOnStartDate) {
                reportDto.rejectedOnStartDate?.setMinutes(
                    reportDto.rejectedOnStartDate?.getMinutes() -
                    reportDto.rejectedOnStartDate?.getTimezoneOffset()
                );
            }
            if (reportDto.rejectedOnEndDate) {
                reportDto.rejectedOnEndDate?.setMinutes(
                    reportDto.rejectedOnEndDate?.getMinutes() -
                    reportDto.rejectedOnEndDate?.getTimezoneOffset()
                );
            }
            if (this.selectedOthBookingItems) {
                if (this.selectedOthBookingItems.length > 0) {
                    let data = [];
                    this.selectedOthBookingItems.forEach(aa => {
                        data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                    });
                    reportDto.bookings = data;
                }
            }

            if (this.selectedOthMERABookingIdItems) {
                if (this.selectedOthMERABookingIdItems.length > 0) {
                    let data = [];
                    this.selectedOthMERABookingIdItems.forEach(aa => {
                        data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                    });
                    reportDto.mERABookings = data;
                }
            }

            if (this.selectedOthRequestorNameItems) {
                if (this.selectedOthRequestorNameItems.length > 0) {
                    let data = [];
                    this.selectedOthRequestorNameItems.forEach(aa => {
                        data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                    });
                    reportDto.requestors = data;
                }
            }

            if (this.selectedOthSubmittedbyItems) {
                if (this.selectedOthSubmittedbyItems.length > 0) {
                    let data = [];
                    this.selectedOthSubmittedbyItems.forEach(aa => {
                        data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                    });
                    reportDto.submittedBy = data;
                }
            }

            if (this.selectedOthApprovedbyItems) {
                if (this.selectedOthApprovedbyItems.length > 0) {
                    let data = [];
                    this.selectedOthApprovedbyItems.forEach(aa => {
                        data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                    });
                    reportDto.approvedBy = data;
                }
            }

            if (this.selectedOthRejectedbyItems) {
                if (this.selectedOthRejectedbyItems.length > 0) {
                    let data = [];
                    this.selectedOthRejectedbyItems.forEach(aa => {
                        data.push({ ID: aa.ID, Text: aa.Text, Code: aa.Text });
                    });
                    reportDto.rejectedBy = data;
                }
            }
        }

        const paramString: string = JSON.stringify(reportDto);
        //  console.log(paramString);
        let reportdata = new SavedReportDto;
        reportdata.reportId = this.ReportMainData.reportId;
        reportdata.isActive = true;
        reportdata.isDeleted = false;
        reportdata.savedReportId = this.ReportMainData.savedReportId;
        reportdata.savedReportName = this.savedReportName.trim();
        reportdata.parameters = paramString;
        reportdata.comments = this.savedReportComments;
        reportdata.isUpdate = isUpdate;
        let param = { base64string: btoa(unescape(encodeURIComponent(JSON.stringify(reportdata)))) };
        let saveReportInputDto = new SaveReportInputDto;
        saveReportInputDto.base64string = param.base64string;

        this.reportService.savedReport(saveReportInputDto).subscribe(response => {
            if (response.customResultId <= 0) {
                console.error('Error saving data ', response.customException);
                this.popupMessageTitle = 'Failed';
                this.popupMessageBody = response.customException;
                this.onScroll();
            }
            else {
                console.log('Data saved successfully', response);
                this.messageTitle = 'Success';
                this.messageBody = "Data saved successfully.";
                this.onScroll();
                this.closeModal();
               
            }
        }, error => {
            console.error('Error saving data', error);
            this.popupMessageTitle = 'Failed';
            this.popupMessageBody = "Unexpected server error. Please try again.";
            this.onScroll();
        }, () => {
            this.spinner.hide();
        });
    }
    closeMessage() {
        this.messageBody = '';
        this.messageTitle = '';
    }
    openModal() {
        if (this.startDate == undefined) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please select date range.";
            this.onScroll();
            return;
        }
        if (this.endDate == undefined) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please select date range.";
            this.onScroll();
            return;
        }
        if (this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE
            && this.resAvailability != null && this.resAvailability != undefined
            && (this.resAvailability < 0 || this.resAvailability > 100)) {
            this.messageTitle = 'Failed';
            this.messageBody = "Please enter Availability (%) between 0 to 100.";
            this.onScroll();
            return;
        }
        this.savedReportComments = '';
        this.savedReportName = '';
        if (this.ReportMainData != undefined && this.ReportMainData.savedReportId > 0 && this.ReportMainData.savedReportName != '') {
            this.savedReportName = this.ReportMainData.savedReportName;
        }
        this.popupMessageBody = '';
        this.popupMessageTitle = '';
        this.modalOption.backdrop = 'static';
        this.modalOption.keyboard = false;
        this.modalRef = this.modalService.show(this.template1, this.modalOption);
        this.modalDisplayed = true;
        
    }
    closeModal() {
        this.modalRef.hide();
        this.modalDisplayed = false;
    }
    SaveAsFilter() {
        this.saveData(false);

    }
    closePopupMessage() {
        this.popupMessageBody = '';
        this.popupMessageTitle = '';
    }

    selectTabVal(tabName: string) {
        this.selectedTabVal = tabName;
    }
    makeDirty() {
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
    }

    changeRank(){
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.resRankSelectedItems.length > 0) {
                let selectedCodes = [];
                this.resRankSelectedItems.forEach(p=> {
                    let Rankcode = this.resRankList.find(obj => obj.ID === p.ID).Code;
                    selectedCodes.push(Rankcode);
                });
                this.GetResourceGrade(selectedCodes);
        }
        else {
                this.GetResourceGrade(null);
             }
        this.spinner.hide();
    }

    changeCountry() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.resManageCountrySelectedItems.length > 0) {
            const selectedIds = this.resManageCountrySelectedItems.map(({ ID }) => ID);
            this.ChangeResourceCompanyCode(selectedIds);
            this.selectedResCountryCode = selectedIds
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
            // this.ChangeResourceDepartment(selectedIds);
            this.ChangeResourceEconomicLocation(selectedIds);
            this.ChangeResourceOfficeLocation(selectedIds);
        }
        else {
            this.ChangeResourceCompanyCode(null);
            this.selectedResCountryCode = null
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
           
            // this.ChangeResourceDepartment(null);
            this.ChangeResourceEconomicLocation(null);
            this.ChangeResourceOfficeLocation(null);
        }
        this.spinner.hide();
    }

    changeSSL() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if ( this.resSubServiceLineSelectedItems.length > 0) 
        {
                this.selectedResSSLIds = this.resSubServiceLineSelectedItems.map(({ ID }) => ID);
                    
            this.changeResourceCompetency( this.selectedResSLIds,this.selectedResSSLIds);
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
           
        }
        else {
            this.selectedResSSLIds = null;
            this.changeResourceCompetency(this.selectedResSLIds,this.selectedResSSLIds);
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
           
        }

        this.spinner.hide();
    }

    changeSL() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
       
        if (this.resServiceLineSelectedItems.length > 0) {
            this.selectedResSLIds = this.resServiceLineSelectedItems.map(({ ID }) => ID);
            this.changeResourceSubServiceLine(this.selectedResSLIds);
            this.changeResourceCompetency(this.selectedResSLIds,this.selectedResSSLIds);
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
        }
        else {
            this.selectedResSLIds = null;
            this.changeResourceSubServiceLine(null);
            this.changeResourceCompetency(this.selectedResSLIds,this.selectedResSSLIds);
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
           
        }
        this.spinner.hide();
    }
    
    changeEngSL() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }

        
        if (this.engServiceLineSelectedItems.length > 0) {

            this.selectedEngSLIds = this.engServiceLineSelectedItems.map(({ ID }) => ID);
            this.ChangeJobCompetency( this.selectedEngSLIds,this.selectedEngSSLIds);
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

            const selectedIds = this.engServiceLineSelectedItems.map(({ ID }) => ID);
            this.ChangeJobSubServiceLine(selectedIds);
           
        }
        else {
            this.selectedEngSLIds = null;
            this.ChangeJobSubServiceLine(null);
            this.ChangeJobCompetency( this.selectedEngSLIds,this.selectedEngSSLIds);
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

        }
        this.spinner.hide();
    }

    changeResCompetency() {
      this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.resCompetencySelectedItems.length > 0) {
            this.selectedResCompetencyCode = this.resCompetencySelectedItems.map(({ ID }) => ID);;
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
        }
        else {
            this.selectedResCompetencyCode = null;
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
        }
        this.spinner.hide();
        
    }

    changeEngCompetency(){
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.engCompetencySelectedItems.length > 0) {
            this.selectedEngCompetencyCode = this.engCompetencySelectedItems.map(({ ID }) => ID);;
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);
        }
        else {
            this.selectedEngCompetencyCode = null;
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);
        }
        this.spinner.hide();
    
    }

    changeEngRegion() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.engRegionSelectedItems.length > 0) {
            const selectedIds = this.engRegionSelectedItems.map(({ ID }) => ID);
            this.ChangeJobCountry(selectedIds);
            this.selectedEngSubAreaCode = selectedIds;
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

        }
        else {
            this.ChangeJobCountry(null);
            this.selectedEngSubAreaCode = null;
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

        }
        this.spinner.hide();
    }

    changeResRegion() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.resRegionSelectedItems.length > 0) {
            const selectedIds = this.resRegionSelectedItems.map(({ ID }) => ID);
            this.ChangeResCountry(selectedIds);
            this.selectedResSubAreaCode = selectedIds;
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
        
        }
        else {
            this.ChangeResCountry(null);
            this.selectedResSubAreaCode = null;
            this.ChangeResourceCostCenter(this.selectedResSLIds,this.selectedResSSLIds,this.selectedResCompetencyCode,this.selectedResSubAreaCode,this.selectedResCountryCode);
        
        }
        this.spinner.hide();
    }

    changeEngSSL() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
      
        if ( this.engSubServiceLineSelectedItems.length > 0) {
            this.selectedEngSSLIds = this.engSubServiceLineSelectedItems.map(({ ID }) => ID);
            this.ChangeJobCompetency( this.selectedEngSLIds,this.selectedEngSSLIds);
        	this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

        }
        else{
            this.selectedEngSSLIds = null;
            this.ChangeJobCompetency( this.selectedEngSLIds,this.selectedEngSSLIds);
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

        }

        this.spinner.hide();
    }

    changeEngCountry() {
        this.spinner.show();
        if (!this.dirtyFlag) {
            this.dirtyFlag = true;
        }
        if (this.engManageCountrySelectedItems.length > 0) {
            const selectedIds = this.engManageCountrySelectedItems.map(({ ID }) => ID);
            this.selectedEngCountryCode = selectedIds;
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);
        }
        else {
            this.selectedEngCountryCode = null;
            this.ChangeJobCostCenter(this.selectedEngSLIds,this.selectedEngSSLIds,this.selectedEngCompetencyCode,this.selectedEngSubAreaCode,this.selectedEngCountryCode);

        }
        this.spinner.hide();
    }

    GetResourceCountry(selectedIds) {
        this.resManageCountryList = [];
        this.resManageCountryLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCountry(selectedIds).subscribe(
                (data) => {
                    this.resManageCountryList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resManageCountryLoader = false;
                    });
                },
                (error) => {
                    this.resManageCountryLoader = false;
                    reject();
                },
                () => {
                    this.resManageCountryLoader = false;
                    console.log('ResourceCountry data fetched');
                }
            );
        });
    }

    GetJobCountry(selectedIds) {
        this.engManageCountryList = [];
        this.engManageCountryLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCountry(selectedIds).subscribe(
                (data) => {
                    this.engManageCountryList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engManageCountryLoader = false;
                    });
                },
                (error) => {
                    this.engManageCountryLoader = false;
                    reject();
                },
                () => {
                    this.engManageCountryLoader = false;
                    console.log('Engagement Country data fetched');
                }
            );
        });
    }
    ChangeJobCountry(selectedIds) {
        this.engManageCountryList = [];
        this.engManageCountryLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCountry(selectedIds).subscribe(
                (data) => {
                    this.engManageCountryList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engManageCountryLoader = false;
                    });
                },
                (error) => {
                    this.engManageCountryLoader = false;
                    reject();
                },
                () => {
                    this.engManageCountryLoader = false;
                    console.log('Engagement Country data fetched');
                    this.FilterSelectedJobCountry();
                }
            );
        });
    }
    FilterSelectedJobCountry() {
        if (this.engManageCountrySelectedItems.length > 0 && this.engManageCountryList.length > 0) {
            this.engManageCountrySelectedItems = this.engManageCountrySelectedItems.filter(item1 => this.engManageCountryList.find(item2 => item1.ID == item2.ID));
        }
        if (this.engManageCountryList.length == 0)
            this.engManageCountrySelectedItems = [];
            this.selectedEngCountryCode = null;
        this.changeEngCountry(); 
    }
    ChangeResCountry(selectedIds) {
        this.resManageCountryList = [];
        this.resManageCountryLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCountry(selectedIds).subscribe(
                (data) => {
                    this.resManageCountryList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resManageCountryLoader = false;
                    });
                },
                (error) => {
                    this.resManageCountryLoader = false;
                    reject();
                },
                () => {
                    this.resManageCountryLoader = false;
                    console.log('Resource Country data fetched');
                    this.FilterSelectedResourceCountry();
                }
            );
        });
    }
    FilterSelectedResourceCountry() {
        if (this.resManageCountrySelectedItems.length > 0 && this.resManageCountryList.length > 0) {
            this.resManageCountrySelectedItems = this.resManageCountrySelectedItems.filter(item1 => this.resManageCountryList.find(item2 => item1.ID == item2.ID));
        }
        if (this.resManageCountryList.length == 0)
            this.resManageCountrySelectedItems = [];
            this.selectedResCountryCode = null;
        this.changeCountry();
    }
    GetResourceType() {
        let no = 0;
        this.resEmployeeTypeList = [];
        this.resEmployeeTypeLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceType().subscribe(
                (data) => {
                    this.resEmployeeTypeList = this.reportService.getDummyArray(data); // Set values to controls
                    this.resEmployeeTypeList.forEach(a => {
                        no = no + 1;
                        a.ID = no;
                    });
                    resolve();
                    this.sleep(500).then(() => {
                        this.resEmployeeTypeLoader = false;
                    });
                },
                (error) => {
                    this.resEmployeeTypeLoader = false;
                    reject();
                },
                () => {
                    this.resEmployeeTypeLoader = false;
                    console.log('ResourceType data fetched');
                    if (this.isUpdate == false && this.isCSULoggedIn && this.loggedInResourceDetails != null && this.loggedInResourceDetails.ResourceType != null && this.loggedInResourceDetails.ResourceType != '' && this.resEmployeeTypeList.length > 0) {
                        this.resEmployeeTypeSelectedItems = [{ ID: this.resEmployeeTypeList.find(item => item.Text == this.loggedInResourceDetails.ResourceType)?.ID, Text: this.loggedInResourceDetails.ResourceType }];
                    }
                }
            );
        });
    }

    GetResourceStatus() {
        let no = 0;
        this.resEmployeeStatusList = [];
        this.resEmployeeStatusLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceStatus().subscribe(
                (data) => {
                    this.resEmployeeStatusList = this.reportService.getDummyArray(data); // Set values to controls
                    this.resEmployeeStatusList.forEach(a => {
                        no = no + 1;
                        a.ID = no;
                    });
                    resolve();
                    this.sleep(500).then(() => {
                        this.resEmployeeStatusLoader = false;
                    });
                },
                (error) => {
                    this.resEmployeeStatusLoader = false;
                    reject();
                },
                () => {
                    this.resEmployeeStatusLoader = false;
                    console.log('ResourceStatus data fetched');
                    if (this.isUpdate == false && this.isCSULoggedIn && this.loggedInResourceDetails != null && this.loggedInResourceDetails.ResourceStatus != null && this.loggedInResourceDetails.ResourceStatus != '' && this.resEmployeeStatusList.length > 0) {
                        this.resEmployeeStatusSelectedItems = [{ ID: this.resEmployeeStatusList.find(item => item.Text == this.loggedInResourceDetails.ResourceStatus)?.ID, Text: this.loggedInResourceDetails.ResourceStatus }];
                    }
                }
            );
        });
    }

    GetResourceServiceLine() {
        this.resServiceLineList = [];
        this.resServiceLineLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceServiceLine().subscribe(
                (data) => {

                    this.resServiceLineList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resServiceLineLoader = false;
                    });

                },
                (error) => {
                    this.resServiceLineLoader = false;
                    reject();
                },
                () => {
                    console.log('ResourceServiceLine data fetched');
                }
            );
        });
    }
    GetJobSubArea() {
        this.engRegionList = [];
        this.engRegionLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobSubArea().subscribe(
                (data) => {
                    this.engRegionList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engRegionLoader = false;
                    });
                },
                (error) => {
                    this.engRegionLoader = false;
                    reject();
                },
                () => {
                    this.engRegionLoader = false;
                    console.log('Engagement Region data fetched');
                }
            );
        });
    }
    GetResRegion() {
        this.resRegionList = [];
        this.resRegionLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceSubArea().subscribe(
                (data) => {
                    this.resRegionList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resRegionLoader = false;
                    });
                },
                (error) => {
                    this.resRegionLoader = false;
                    reject();
                },
                () => {
                    this.resRegionLoader = false;
                    console.log('Resource Region data fetched');
                }
            );
        });
    }
    GetResSubRegion() {
        this.resSubRegionList = [];
        this.resSubRegionLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceSubRegion().subscribe(
                (data) => {
                    this.resSubRegionList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resSubRegionLoader = false;
                    });
                },
                (error) => {
                    this.resSubRegionLoader = false;
                    reject();
                },
                () => {
                    this.resSubRegionLoader = false;
                    console.log('Resource Sub Region data fetched');
                }
            );
        });
    }
    GetJobStatus() {
        this.engJobStatusList = [];
        this.engJobStatusLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobStatus().subscribe(
                (data) => {
                    this.engJobStatusList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engJobStatusLoader = false;
                    });
                },
                (error) => {
                    this.engJobStatusLoader = false;
                    reject();
                },
                () => {
                    this.engJobStatusLoader = false;
                    console.log('Engagement status data fetched');
                }
            );
        });
    }
    GetCustomerIndustry() {
        this.engCustomerIndustryList = [];
        this.engCustomerIndustryLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetCustomerIndustry().subscribe(
                (data) => {
                    this.engCustomerIndustryList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engCustomerIndustryLoader = false;
                    });
                },
                (error) => {
                    this.engCustomerIndustryLoader = false;
                    reject();
                },
                () => {
                    this.engCustomerIndustryLoader = false;
                    console.log('Customer industry data fetched');
                }
            );
        });
    }
    GetCustomerPriorityStatus() {
        this.engCustomerPriorityStatusList = [];
        this.engCustomerPriorityStatusLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetCustomerPriorityStatus().subscribe(
                (data) => {
                    this.engCustomerPriorityStatusList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engCustomerPriorityStatusLoader = false;
                    });
                },
                (error) => {
                    this.engCustomerPriorityStatusLoader = false;
                    reject();
                },
                () => {
                    this.engCustomerPriorityStatusLoader = false;
                    console.log('CustomerPriorityStatus data fetched');
                }
            );
        });
    }
    GetJobServiceLine() {
        this.engServiceLineList = [];
        this.engServiceLineLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobServiceLine().subscribe(
                (data) => {
                    this.engServiceLineList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engServiceLineLoader = false;
                    });
                },
                (error) => {
                    this.engServiceLineLoader = false;
                    reject();
                },
                () => {
                    this.engServiceLineLoader = false;
                    console.log('Engagement service line data fetched');
                }
            );
        });
    }
    GetResourceLevel() {
        this.resLevelList = [];
        this.resLevelLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceLevel().subscribe(
                (data) => {
                    this.resLevelList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resLevelLoader = false;
                    });
                },
                (error) => {
                    this.resLevelLoader = false;
                    reject();
                },
                () => {
                    this.resLevelLoader = false;
                    console.log('Resource level data fetched');
                }
            );
        });
    }

    
    GetResourceGrade(selectedRankIds: any[]) {
        this.resGradeList = [];
        this.resGradeLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceGrade(selectedRankIds).subscribe(
                (data) => {
                    this.resGradeList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resGradeLoader = false;
                    });
                },
                (error) => {
                    this.resGradeLoader = false;
                    reject();
                },
                () => {
                    this.resGradeLoader = false;
                    console.log('Resource grade data fetched');
                }
            );
        });
    }
    GetResourceRank() {
        this.resRankList = [];
        this.resRankLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceRank().subscribe(
                (data) => {
                    this.resRankList = this.reportService.getDummyArrayWithCode(data); // Set values to controls
                  
                    resolve();
                    this.sleep(500).then(() => {
                        this.resRankLoader = false;
                    });
                },
                (error) => {
                    this.resRankLoader = false;
                    reject();
                },
                () => {
                    this.resRankLoader = false;
                    console.log('Resource rank data fetched');
                }
            );
        });
    }
    GetResourceGDSRegionAlignment() {
        this.resGDSRegionAlignmentList = [];
        this.resGDSRegionAlignmentLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceGDSRegionAlignment().subscribe(
                (data) => {
                    this.resGDSRegionAlignmentList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resGDSRegionAlignmentLoader = false;
                    });
                },
                (error) => {
                    this.resGDSRegionAlignmentLoader = false;
                    reject();
                },
                () => {
                    this.resGDSRegionAlignmentLoader = false;
                    console.log('GDSRegionAlignment data fetched');
                }
            );
        });
    }
    GetJobCategoery() {
        this.engagementTypes = [];
        this.engagementTypesLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCategoery().subscribe(
                (data) => {
                    this.engagementTypes = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engagementTypesLoader = false;
                    });
                },
                (error) => {
                    this.engagementTypesLoader = false;
                    reject();
                },
                () => {
                    this.engagementTypesLoader = false;
                    console.log('engagementTypes data fetched');
                }
            );
        });
    }
    GetJobType() {
        this.engagementSubTypes = [];
        this.engEngagementSubTypesLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobType().subscribe(
                (data) => {
                    this.engagementSubTypes = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engEngagementSubTypesLoader = false;
                    });
                },
                (error) => {
                    this.engEngagementSubTypesLoader = false;
                    reject();
                },
                () => {
                    this.engEngagementSubTypesLoader = false;
                    console.log('engagementSubTypes data fetched');
                }
            );
        });
    }
    GetResourceSubServiceLine(selectedIds: any[]) {
        this.resSubServiceLineList = [];
        this.resSubServiceLineLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceSubServiceLine(selectedIds).subscribe(
                (data) => {

                    this.resSubServiceLineList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resSubServiceLineLoader = false;
                    });
                },
                (error) => {
                    this.resSubServiceLineLoader = false;
                    reject();

                },
                () => {
                    this.resSubServiceLineLoader = false;
                    console.log('ResourceSubServiceLine data fetched');
                }
            );
        });
    }
    changeResourceSubServiceLine(selectedIds: any[]) {
        this.resSubServiceLineList = [];
        this.resSubServiceLineLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceSubServiceLine(selectedIds).subscribe(
                (data) => {
                    this.resSubServiceLineList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resSubServiceLineLoader = false;
                    });
                },
                (error) => {
                    this.resSubServiceLineLoader = false;
                    reject();
                },
                () => {
                    console.log('ResourceSubServiceLine data fetched');
                    this.resSubServiceLineLoader = false;
                    this.FilterSelectedResourceSubServiceLine();
                }
            );
        });
    }
    FilterSelectedResourceSubServiceLine() {
        if (this.resSubServiceLineSelectedItems.length > 0 && this.resSubServiceLineList.length > 0) {
            this.resSubServiceLineSelectedItems = this.resSubServiceLineSelectedItems.filter(item1 => this.resSubServiceLineList.find(item2 => item1.ID == item2.ID));
        }
        if (this.resSubServiceLineList.length == 0)
            this.resSubServiceLineSelectedItems = [];
            this.selectedResSSLIds = null;
        this.changeSSL();
    }
    GetJobSubServiceLine(selectedIds: any[]) {
        this.engSubServiceLineList = [];
        this.engSubServiceLineLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobSubServiceLine(selectedIds).subscribe(
                (data) => {
                    this.engSubServiceLineList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engSubServiceLineLoader = false;
                    });
                },
                (error) => {
                    this.engSubServiceLineLoader = false;
                    reject();
                },
                () => {
                    this.engSubServiceLineLoader = false;
                    console.log('engSubServiceLineList data fetched');
                    this.FilterSelectedEngSubServiceLine();
                }
            );
        });
    }
    ChangeJobSubServiceLine(selectedIds: any[]) {
        this.engSubServiceLineList = [];
        this.engSubServiceLineLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobSubServiceLine(selectedIds).subscribe(
                (data) => {
                    this.engSubServiceLineList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engSubServiceLineLoader = false;
                    });
                },
                (error) => {
                    this.engSubServiceLineLoader = false;
                    reject();
                },
                () => {
                    this.engSubServiceLineLoader = false;
                    console.log('engSubServiceLineList data fetched');
                    this.FilterSelectedEngSubServiceLine();
                }
            );
        });
    }
    FilterSelectedEngSubServiceLine() {
        if (this.engSubServiceLineSelectedItems.length > 0 && this.engSubServiceLineList.length > 0) {
            this.engSubServiceLineSelectedItems = this.engSubServiceLineSelectedItems.filter(item1 => this.engSubServiceLineList.find(item2 => item1.ID == item2.ID));
        }
        if (this.engSubServiceLineList.length == 0)
            this.engSubServiceLineSelectedItems = [];
            this.selectedEngSSLIds = null;
        this.changeEngSSL();
    }
    GetResourceCompetency(selectedservicesIds: any[], selectedSubservicesId: any[]) {
        this.resCompetencyList = [];
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCompetency(selectedservicesIds,selectedSubservicesId).subscribe(
                (data) => {
                    this.resCompetencyLoader = true;
                    this.resCompetencyList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resCompetencyLoader = false;
                    });
                },
                (error) => {
                    this.resCompetencyLoader = false;
                    reject();
                },
                () => {
                    this.resCompetencyLoader = false;
                    console.log('resCompetencyList data fetched');
                    this.FilterSelectedResourceCompetency();
                }
            );
        });
    }
    changeResourceCompetency(selectedIdsService: any[],selectedIdSubservices: any[]) {
         this.resCompetencyLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCompetency(selectedIdsService,selectedIdSubservices).subscribe(
                (data) => {
                    //this.resCompetencyLoader = true;
                    this.resCompetencyList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resCompetencyLoader = false;
                    });
                },
                (error) => {
                    this.resCompetencyLoader = false;
                    reject();
                },
                () => {
                    console.log('resCompetencyList data fetched');
                    this.resCompetencyLoader = false;
                    this.FilterSelectedResourceCompetency();
                }
            );
        });
    }
    FilterSelectedResourceCompetency() {
       if (this.resCompetencySelectedItems.length > 0 && this.resCompetencyList.length > 0) {
            this.resCompetencySelectedItems = this.resCompetencySelectedItems.filter(item1 => this.resCompetencyList.find(item2 => item1.ID == item2.ID));
        }
        if (this.resCompetencyList.length == 0)
            this.resCompetencySelectedItems = [];
            this.selectedResCompetencyCode = null;
            this.changeResCompetency();
    }


    GetJobCompetency(selectedEngIdsService: any[],selectedEngIdSubservices: any[]) {
        this.engCompetencyList = [];

        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCompetency(selectedEngIdsService,selectedEngIdSubservices).subscribe(
                (data) => {
                    this.engCompetencyLoader = true;
                    this.engCompetencyList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engCompetencyLoader = false;
                    });
                },
                (error) => {
                    this.engCompetencyLoader = false;
                    reject();
                },
                () => {
                    this.engCompetencyLoader = false;
                    console.log('engCompetencyList data fetched');
                }
            );
        });
    }
    ChangeJobCompetency(selectedEngIdsService: any[],selectedEngIdSubservices: any[]) {
        this.engCompetencyList = [];
        this.engCompetencyLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCompetency( selectedEngIdsService,selectedEngIdSubservices).subscribe(
                (data) => {
                    this.engCompetencyList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engCompetencyLoader = false;
                    });
                },
                (error) => {
                    this.engCompetencyLoader = false;
                    reject();
                },
                () => {
                    this.engCompetencyLoader = false;
                    console.log('engCompetencyList data fetched');
                    if (this.engCompetencySelectedItems.length > 0 && this.engCompetencyList.length > 0) {
                        this.engCompetencySelectedItems = this.engCompetencySelectedItems.filter(item1 => this.engCompetencyList.find(item2 => item1.ID == item2.ID));
                    }
                    if (this.engCompetencyList.length == 0)
                        this.engCompetencySelectedItems = [];
                        this.selectedEngCompetencyCode = null;
                        this.changeEngCompetency();
                }
            );
        });
    }
    GetResourceCompanyCode(selectedIds: any[]) {
        this.resCompanyCodeList = [];

        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCompanyCode(selectedIds).subscribe(
                (data) => {
                    this.resCompanyCodeLoader = true;
                    this.resCompanyCodeList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resCompanyCodeLoader = false;
                    });
                },
                (error) => {
                    this.resCompanyCodeLoader = false;
                    reject();
                },
                () => {
                    this.resCompanyCodeLoader = false;
                    console.log('resCompanyCodeList data fetched');
                    if (this.resCompanyCodeSelectedItems.length > 0 && this.resCompanyCodeList.length > 0) {
                        this.resCompanyCodeSelectedItems = this.resCompanyCodeSelectedItems.filter(item1 => this.resCompanyCodeList.find(item2 => item1.ID == item2.ID));
                    }
                }
            );
        });
    }
    ChangeResourceCompanyCode(selectedIds: any[]) {
        this.resCompanyCodeList = [];
        this.resCompanyCodeLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCompanyCode(selectedIds).subscribe(
                (data) => {
                    this.resCompanyCodeList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resCompanyCodeLoader = false;
                    });
                },
                (error) => {
                    this.resCompanyCodeLoader = false;
                    reject();
                },
                () => {
                    this.resCompanyCodeLoader = false;
                    console.log('resCompanyCodeList data fetched');
                    if (this.resCompanyCodeSelectedItems.length > 0 && this.resCompanyCodeList.length > 0) {
                        this.resCompanyCodeSelectedItems = this.resCompanyCodeSelectedItems.filter(item1 => this.resCompanyCodeList.find(item2 => item1.ID == item2.ID));
                    }
                    if (this.resCompanyCodeList.length == 0)
                        this.resCompanyCodeSelectedItems = [];
                  }
            );
        });
    }
    GetResourceCostCenter(selectedSLIds: any[],selectedSSLIds: any[],selectedCompetencyIds: any[],selectedSubAreaIds: any[],selectedCountryIds: any[]) {
        this.resViewCostCenterList = [];

        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCostCenter(selectedSLIds,selectedSSLIds,selectedCompetencyIds,selectedSubAreaIds,selectedCountryIds).subscribe(
                (data) => {
                    this.resViewCostCenterLoader = true;
                    this.resViewCostCenterList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resViewCostCenterLoader = false;
                    });
                },
                (error) => {
                    this.resViewCostCenterLoader = false;
                    reject();
                },
                () => {
                    this.resViewCostCenterLoader = false;
                    console.log('resViewCostCenterList data fetched');
                }
            );
        });
    }

    ChangeResourceCostCenter(selectedSLIds: any[],selectedSSLIds: any[],selectedCompetencyIds: any[],selectedSubAreaIds: any[],selectedCountryIds: any[]) {
        this.resViewCostCenterList = [];
        this.resViewCostCenterLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceCostCenter(selectedSLIds,selectedSSLIds,selectedCompetencyIds,selectedSubAreaIds,selectedCountryIds).subscribe(
                (data) => {
                    this.resViewCostCenterList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resViewCostCenterLoader = false;
                    });
                },
                (error) => {
                    this.resViewCostCenterLoader = false;
                    reject();
                },
                () => {
                    this.resViewCostCenterLoader = false;
                    console.log('resViewCostCenterList data fetched');
                    if (this.resViewCostCenterSelectedItems.length > 0 && this.resViewCostCenterList.length > 0) {
                        this.resViewCostCenterSelectedItems = this.resViewCostCenterSelectedItems.filter(item1 => this.resViewCostCenterList.find(item2 => item1.ID == item2.ID));
                    }
                    if (this.resViewCostCenterList.length == 0)
                        this.resViewCostCenterSelectedItems = [];
                }
            );
        });
    }

    GetJobCostCenter(selectedSLIds: any[],selectedSSLIds: any[],selectedCompetencyIds: any[],selectedSubAreaIds: any[],selectedCountryIds: any[]) {
        this.engCostCenterList = [];

        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCostCenter(selectedSLIds,selectedSSLIds,selectedCompetencyIds,selectedSubAreaIds,selectedCountryIds).subscribe(
                (data) => {
                    this.engCostCenterLoader = true;
                    this.engCostCenterList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engCostCenterLoader = false;
                    });
                },
                (error) => {
                    this.engCostCenterLoader = false;
                    reject();
                },
                () => {
                    this.engCostCenterLoader = false;
                    console.log('engCostCenterList data fetched');
                }
            );
        });
    }
    
    ChangeJobCostCenter(selectedSLIds: any[],selectedSSLIds: any[],selectedCompetencyIds: any[],selectedSubAreaIds: any[],selectedCountryIds: any[]) {
        this.engCostCenterList = [];
        this.engCostCenterLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetJobCostCenter(selectedSLIds,selectedSSLIds,selectedCompetencyIds,selectedSubAreaIds,selectedCountryIds).subscribe(
                (data) => {
                    this.engCostCenterList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.engCostCenterLoader = false;
                    });
                },
                (error) => {
                    this.engCostCenterLoader = false;
                    reject();
                },
                () => {
                    this.engCostCenterLoader = false;
                    console.log('engCostCenterList data fetched');
                    if (this.engCostCenterSelectedItems.length > 0 && this.engCostCenterList.length > 0) {
                        this.engCostCenterSelectedItems = this.engCostCenterSelectedItems.filter(item1 => this.engCostCenterList.find(item2 => item1.ID == item2.ID));
                    }
                    if (this.engCostCenterList.length == 0)
                        this.engCostCenterSelectedItems = [];
                }
            );
        });
    }
    // GetResourceDepartment(selectedIds: any[]) {
    //     this.resDepartmentList = [];
    //     this.resDepartmentLoader = true;
    //     return new Promise<void>((resolve, reject) => {
    //         this.reportService.GetResourceDepartment(selectedIds).subscribe(
    //             (data) => {
    //                 this.resDepartmentList = this.reportService.getDummyArray(data); // Set values to controls
    //                 resolve();
    //                 this.sleep(500).then(() => {
    //                     this.resDepartmentLoader = false;
    //                 });
    //             },
    //             (error) => {
    //                 this.resDepartmentLoader = false;
    //                 reject();
    //             },
    //             () => {
    //                 this.resDepartmentLoader = false;
    //                 console.log('resDepartmentList data fetched');
    //             }
    //         );
    //     });
    // }
    // ChangeResourceDepartment(selectedIds: any[]) {
    //     this.resDepartmentList = [];
    //     this.resDepartmentLoader = true;
    //     return new Promise<void>((resolve, reject) => {
    //         this.reportService.GetResourceDepartment(selectedIds).subscribe(
    //             (data) => {
    //                 this.resDepartmentList = this.reportService.getDummyArray(data); // Set values to controls
    //                 resolve();
    //                 this.sleep(500).then(() => {
    //                     this.resDepartmentLoader = false;
    //                 });
    //             },
    //             (error) => {
    //                 this.resDepartmentLoader = false;
    //                 reject();
    //             },
    //             () => {
    //                 this.resDepartmentLoader = false;
    //                 console.log('resDepartmentList data fetched');
    //                 if (this.resDepartmentSelectedItems.length > 0 && this.resDepartmentList.length > 0) {
    //                     this.resDepartmentSelectedItems = this.resDepartmentSelectedItems.filter(item1 => this.resDepartmentList.find(item2 => item1.ID == item2.ID));
    //                 }
    //             }
    //         );
    //     });
    // }
    GetResourceEconomicLocation(selectedIds: any[]) {
        this.resEconomicLocationList = [];
        this.resEconomicLocationLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceEconomicLocation(selectedIds).subscribe(
                (data) => {
                    this.resEconomicLocationList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resEconomicLocationLoader = false;
                    });
                },
                (error) => {
                    this.resEconomicLocationLoader = false;
                    reject();
                },
                () => {
                    this.resEconomicLocationLoader = false;
                    console.log('resEconomicLocationList data fetched');
                    if (this.resEconomicLocationSelectedItems.length > 0 && this.resEconomicLocationList.length > 0) {
                        this.resEconomicLocationSelectedItems = this.resEconomicLocationSelectedItems.filter(item1 => this.resEconomicLocationList.find(item2 => item1.ID == item2.ID));
                    }
                }
            );
        });
    }

    ChangeResourceEconomicLocation(selectedIds: any[]) {
        this.resEconomicLocationList = [];
        this.resEconomicLocationLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceEconomicLocation(selectedIds).subscribe(
                (data) => {
                    this.resEconomicLocationList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resEconomicLocationLoader = false;
                    });
                },
                (error) => {
                    this.resEconomicLocationLoader = false;
                    reject();
                },
                () => {
                    this.resEconomicLocationLoader = false;
                    console.log('resEconomicLocationList data fetched');
                    if (this.resEconomicLocationSelectedItems.length > 0 && this.resEconomicLocationList.length > 0) {
                        this.resEconomicLocationSelectedItems = this.resEconomicLocationSelectedItems.filter(item1 => this.resEconomicLocationList.find(item2 => item1.ID == item2.ID));
                    }
                    if (this.resEconomicLocationList.length == 0)
                        this.resEconomicLocationSelectedItems = [];
                }
            );
        });
    }
    GetResourceOfficeLocation(selectedIds: any[]) {
        this.resOfficeLocationItems = [];
        this.resOfficeLocationLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceOfficeLocation(selectedIds).subscribe(
                (data) => {
                    this.resOfficeLocationItems = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resOfficeLocationLoader = false;
                    });
                },
                (error) => {
                    this.resOfficeLocationLoader = false;
                    reject();
                },
                () => {
                    this.resOfficeLocationLoader = false;
                    console.log('resOfficeLocationItems data fetched');
                    if (this.resOfficeLocationSelectedItems.length > 0 && this.resOfficeLocationItems.length > 0) {
                        this.resOfficeLocationSelectedItems = this.resOfficeLocationSelectedItems.filter(item1 => this.resOfficeLocationItems.find(item2 => item1.ID == item2.ID));
                    }
                }
            );
        });
    }
    ChangeResourceOfficeLocation(selectedIds: any[]) {
        this.resOfficeLocationItems = [];
        this.resOfficeLocationLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceOfficeLocation(selectedIds).subscribe(
                (data) => {
                    this.resOfficeLocationItems = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.resOfficeLocationLoader = false;
                    });
                },
                (error) => {
                    this.resOfficeLocationLoader = false;
                    reject();
                },
                () => {
                    this.resOfficeLocationLoader = false;
                    console.log('resOfficeLocationItems data fetched');
                    if (this.resOfficeLocationSelectedItems.length > 0 && this.resOfficeLocationItems.length > 0) {
                        this.resOfficeLocationSelectedItems = this.resOfficeLocationSelectedItems.filter(item1 => this.resOfficeLocationItems.find(item2 => item1.ID == item2.ID));
                    }
                    if (this.resOfficeLocationItems.length == 0)
                        this.resOfficeLocationSelectedItems = [];
                }
            );
        });
    }
    GetOtherBookingType() {
        this.othBookingTypeList = [];
        this.othBookingTypeLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetOtherBookingType().subscribe(
                (data) => {
                    this.othBookingTypeList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.othBookingTypeLoader = false;
                    });
                },
                (error) => {
                    this.othBookingTypeLoader = false;
                    reject();
                },
                () => {
                    this.othBookingTypeLoader = false;
                    console.log('OtherBookingType data fetched');
                }
            );
        });
    }
    GetOtherMERAAction() {
        this.othMERAActionList = [];
        this.othMERAActionLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetOtherMERAAction().subscribe(
                (data) => {
                    this.othMERAActionList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.othMERAActionLoader = false;
                    });
                },
                (error) => {
                    this.othMERAActionLoader = false;
                    reject();
                },
                () => {
                    this.othMERAActionLoader = false;
                    console.log('OtherMERAAction data fetched');
                }
            );
        });
    }
    GetOtherMeraRequestMode() {
        this.othMeraRequestModeList = [];
        this.othMeraRequestModeLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetOtherMeraRequestMode().subscribe(
                (data) => {
                    this.othMeraRequestModeList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.othMeraRequestModeLoader = false;
                    });
                },
                (error) => {
                    this.othMeraRequestModeLoader = false;
                    reject();
                },
                () => {
                    this.othMeraRequestModeLoader = false;
                    console.log('OtherMeraRequestMode data fetched');
                }
            );
        });
    }
    GetOtherMeraBookingStatus() {
        this.othMeraBookingStatusList = [];
        this.othMeraBookingStatusLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetOtherMeraBookingStatus().subscribe(
                (data) => {
                    this.othMeraBookingStatusList = this.reportService.getDummyArray(data); // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                        this.othMeraBookingStatusLoader = false;
                    });
                },
                (error) => {
                    this.othMeraBookingStatusLoader = false;
                    reject();
                },
                () => {
                    this.othMeraBookingStatusLoader = false;
                    console.log('OtherMeraBookingStatus data fetched');
                }
            );
        });
    }
    GetOtherMeraStatusInformation() {
        let no = 0;
        this.othMeraStatusInformationList = [];
        this.othMeraStatusInformationLoader = true;
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetOtherMeraStatusInformation().subscribe(
                (data) => {
                    this.othMeraStatusInformationList = this.reportService.getDummyArray(data); // Set values to controls
                    this.othMeraStatusInformationList.forEach(a => {
                        no = no + 1;
                        a.ID = no;
                    });
                    resolve();
                    this.sleep(500).then(() => {
                        this.othMeraStatusInformationLoader = false;
                    });
                },
                (error) => {
                    this.othMeraStatusInformationLoader = false;
                    reject();
                },
                () => {
                    this.othMeraStatusInformationLoader = false;
                    console.log('OtherMeraStatusInformation data fetched');
                }
            );
        });
    }
    onReportStartDateChange(event: any) {
        this.startDate = this.range.get('start').value;
        this.endDate = null;
    }
    onReportEndDateChange(event: any) {
        this.endDate = this.range.get('end').value;
        if (event.value != null) {
            if (this.endDate != null) {
                this.startDate = new Date(this.startDate);
                this.endDate = new Date(this.endDate);
            }
        }
    }
    resetfilter(event) {
        event.stopPropagation();
        event.preventDefault();
        this.range.setValue({
            start: null,
            end: null,
        });
        this.startDate = null;
        this.endDate = null;
    }
    OnClosedDatePicker() {
        if (this.startDate != null && this.endDate == null) {
            setTimeout(() => {
                this.startDate = null;
                this.endDate = null;
                this.range.setValue({
                    start: null,
                    end: null,
                });
            }, 3000);
        }
    }

    loadResSelectedItem() {
        if (this.selectedResItems) {
            if (this.selectedResItems.length > 0) {
                this.showSearchList = false;
                this.showFavouriteResList = true;
                this.getResSortedData();
            }
        }
    }

    // IT
    onCloseSelectedResItems(item) {
        this.isRemoveSelectedResItems = true;
        this.selectedResItems = this.selectedResItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getResSortedData();
    }

    onCloseCounsellorItems(item) {
        this.isRemoveSelectedCouncellorItems = true;
        this.selectedCounsellorItems = this.selectedCounsellorItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getSortedDataCounsellor();
    }

    onCloseEngItems(item) {
        this.isRemoveSelectedEngItems = true;
        this.selectedEngItems = this.selectedEngItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getSortedDataEng();
    }

    onCloseEngMangerItems(item) {
        this.isRemoveSelectedEngMangerItems = true;
        this.selectedEngManagerItems = this.selectedEngManagerItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getSortedDataEngManager();
    }

    onCloseEngPartnerItems(item) {
        this.isRemoveSelectedEngPatnerItems = true;
        this.selectedEngPartnerItems = this.selectedEngPartnerItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getSortedDataEngPartner();
    }

    onCloseEngCustomerItems(item) {
        this.isRemoveSelectedEngCustItems = true;
        this.selectedEngCustomerItems = this.selectedEngCustomerItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getSortedDataEngCustomer();
    }



    onCloseEngUltCustItems(item) {
        this.isRemoveSelectedEngUltCustItems = true;
        this.selectedEngUltCustItems = this.selectedEngUltCustItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getSortedDataEngUltCust();
    }

    onCloseOtherApprovedbyItems(item) {
        this.isRemoveSelectedOthApprovedbyItems = true;
        this.selectedOthApprovedbyItems = this.selectedOthApprovedbyItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getOtherApprovedbySortedData();
    }

    onCloseOtherSubmittedbyItems(item) {
        this.isRemoveSelectedOthSubmittedbyItems = true;
        this.selectedOthSubmittedbyItems = this.selectedOthSubmittedbyItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getOtherSubmittedbySortedData();
    }

    onCloseOtherRejectedbyItems(item) {
        this.isRemoveSelectedOthRejectedbyItems = true;
        this.selectedOthRejectedbyItems = this.selectedOthRejectedbyItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getOtherRejectedbySortedData();
    }

    onCloseResEmployeeDepartmentItems(item) {
        this.isRemoveSelectedResEmployeeDepartmentItems = true;
        this.selectedResEmployeeDepartmentItems = this.selectedResEmployeeDepartmentItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getResEmployeeDepartmentSortedData();
    }


    onCloseOtherRequestorNameItems(item) {
        this.isRemoveSelectedOthRequestorNameItems = true;
        this.selectedOthRequestorNameItems = this.selectedOthRequestorNameItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getOtherRequestorNameSortedData();
    }

    onCloseOtherMERABookingIdItems(item) {
        this.isRemoveSelectedOthMERABookingIdItems = true;
        this.selectedOthMERABookingIdItems = this.selectedOthMERABookingIdItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getOtherMERABookingsIdSortedData();
    }

    onCloseOtherRetainBookingIdItems(item) {
        this.isRemoveSelectedOthRetainBookingIdItems = true;
        this.selectedOthBookingItems = this.selectedOthBookingItems.filter(selectedItem => selectedItem.ID !== item.ID);
        this.getOtherBookingsIdSortedData();
    }


    search() {
        if (this.searchBar != null) {
            if (this.searchBar.trim().length >= 2) {
                this.addFavouriteResResults = [];
                this.showSearchList = false;
                this.showFavouriteResList = true;
                this.showSearchLoader = true;
                this.resource = new SearchResourceDto();
                this.resource.SearchKey = this.searchBar.trim();
                this.resource.ResourceId = 0;
                this.resource.InstanceId = this.selectedInstance;
                if (this.ReportMainData.reportCode == Report.ReportCode.ADOPTION_REPORTCODE)
                    this.resource.ResourceSource = 'AR';
                else if (this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE)
                    this.resource.ResourceSource = 'AV';
                else
                    this.resource.ResourceSource = '';
                
                this.resourceListSubscription = this.reportService
                    .SearchResource(this.resource)
                    .subscribe((data) => {
                        this.sortedResourceList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedResourceList.length > 0) {
                            this.results = this.sortedResourceList;
                            
                            this.results.forEach(aa => {
                                this.addFavouriteResResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.ResourceName, IsSelected: false })
                            });
                            if (this.addFavouriteResResults) {
                                this.getResSortedData();
                            }
                            this.showSearchLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouriteResResults = [];
                            this.showSearchList = false;
                            this.showSearchLoader = false;
                            this.IsDataNotFound = true;

                        }
                    });
            } else {
                this.results = [];
                //this.addFavouriteResResults = [];
                this.showSearchList = false;
                this.IsDataNotFound = false;
            }
        } else {
            this.results = [];
            //this.addFavouriteResResults = [];
            this.showSearchList = false;
            this.IsDataNotFound = false;
        }
    }


    onCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedResItems.push(item);
        } else {
            this.selectedResItems = this.selectedResItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getResSortedData();
    }

    private getResSortedData() {
        this.selectedResItems.forEach(obj => {
            if (this.addFavouriteResResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteResResults = this.addFavouriteResResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteResResults.push(obj);
        });

        this.addFavouriteResResults.forEach(obj => {
            obj.IsSelected = this.selectedResItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedResItems) {
            var uniqueData = this.addFavouriteResResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteResResults = arr;
            this.showFavouriteResList = true;
            // this.reportdata.resource = this.selectedResItems;
        }
    }

    isSelected(item: ReportVM): boolean {
        return this.selectedResItems.some(selectedItem => selectedItem.ID === item.ID);
    }



    resetfilterResourceSearchBar() {
        this.searchBar = '';
        // this.showFavouriteResList = false;
        // this.onResourceClear();
    }
    onResourceClear() {
        this.searchBar = '';
        this.results = [];
        this.selectedResource = new SearchResourceResultDto();
        this.selectedResItems = [];

    }
    OnItemSelect(event) {
        this.showFavouriteResList = true,
            this.showSearchList = false;
        this.selectedResource = event;
        this.searchBar = event.ResourceName;
        this.isClickonFavEngStart = false;
        if (this.selectedResource.ResourceEmail == this.user.Email) {
            this.individualService
                .getProfilePhoto(this.selectedResource.ResourceEmail)
                .subscribe((photoUrl) => {
                    this.selectedResource.ResourcePhotoUrl = photoUrl;
                });
        }
    }


    //v3
    searchEng() {

        this.isVerifyOnEngClick = false;
        this.sortedEngagementList = [];
        this.addFavouriteEngResults = [];
        this.sortedEngagementList = [];

        if (this.engSearchBar != null) {
            if (this.engSearchBar.trim().length >= 2) {
                //this.showEngSearchList = true;
                this.showFavouriteEngList = true;
                this.showEngSearchLoader = true;
                this.engagementSearch = new SearchEngagementDto();
                this.engagementSearch.SearchKey = this.engSearchBar.trim();
                this.engagementSearch.InstanceId = this.selectedInstance;
                this.engagementSearch.JobId = 0;
                this.engagementListSubscription = this.reportService
                    .SearchEngagement(this.engagementSearch)
                    .subscribe((data) => {
                        this.sortedJobList = this.orderPipe.transform(
                            data,
                            'JobDescription'
                        );

                        this.sortedEngagementList = data;

                        if (this.sortedEngagementList.length > 0) {
                        
                            this.sortedEngagementList.forEach(aa => {
                                this.addFavouriteEngResults.push({ ID: aa.JobId, Text: aa.JobDescription, Code: aa.JobCode, IsSelected: false })
                            });
                            if (this.addFavouriteEngResults) {
                                this.getSortedDataEng();
                            }

                            this.engResults = data;
                            this.showEngSearchLoader = false;
                        }

                        else {
                            this.IsDataNotFound = true;
                            this.showEngSearchLoader = false;
                            this.addFavouriteEngResults = [];
                        }
                    });
            } else {
                this.IsDataNotFound = true;
                this.showEngSearchLoader = false;
                this.addFavouriteEngResults = [];
                this.showFavouriteEngList = false;
            }
        } else {
            this.addFavouriteEngResults = [];
            this.showFavouriteEngList = false;
            this.IsDataNotFound = true;
            this.showEngSearchLoader = false;

        }
    }


    loadEngSelectedItem() {
        if (this.selectedEngItems) {
            if (this.selectedEngItems.length > 0) {
                this.showSearchList = false;
                this.showFavouriteEngList = true;
                this.getSortedDataEng();
            }
        }
    }

    closeDivEng() {

        if (this.isRemoveSelectedEngItems == false) {
            this.addFavouriteEngResults = [];
            this.showFavouriteEngList = false;
        } else {
            this.isRemoveSelectedEngItems = false;
        }
        this.IsDataNotFound = false;
    }

    onCheckboxChangeEng(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedEngItems.push(item);
        } else {
            this.selectedEngItems = this.selectedEngItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getSortedDataEng();
    }

    private getSortedDataEng() {
        this.selectedEngItems.forEach(obj => {
            if (this.addFavouriteEngResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteEngResults = this.addFavouriteEngResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteEngResults.push(obj);
        });

        this.addFavouriteEngResults.forEach(obj => {
            obj.IsSelected = this.selectedEngItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedEngItems) {
            var uniqueData = this.addFavouriteEngResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteEngResults = arr;
            this.showFavouriteEngList = true;
        }
    }

    isSelectedEng(item: ReportVM): boolean {
        return this.selectedEngItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    private setAllFavEngagement(): void {
        this.sortedEngagementList.forEach((a) => {
            if (a.IsFavourite === true) {
                a.IsFavEngInserted = true;
                a.favEngSrc = favEngImageSrc.favEngImgStarfilled;
            } else {
                a.IsFavEngInserted = false;
                a.favEngSrc = favEngImageSrc.favEngImgStarOutline;
            }
        });
    }

    resetfilterEngagementSearchBar() {
        this.engSearchBar = '';
        // this.OnEnagementClear();
        this.engagementService.setSelectedJob(this.JobId);
    }

    OnEnagementClear() {
        this.engResults = [];
        this.showEngSearchList = false;
        this.showFavouriteEngList = false;
        this.engSearchBar = '';
        this.selectedJobName = '';
        this.engagementCode = '';
        this.JobId = 0;
        this.isFavEngONClick = true;
        this.IsDataNotFound = false;
        this.addFavouriteEngResults = [];
        this.EngagementTitle = '';
        this.engagementStatus = '';
        this.engagementType = '';
        this.engagementServiceLine = '';
        this.engagementServiceCode = '';
        this.selectedEngItems = [];
    }
    selectedTooltipItem: any;
    selectItem(item) {
        this.selectedTooltipItem = item.TooltipData;
    }


    onFavEngagementSearch(event) {
        if (this.user?.R_Expand_Wallchart)
            if (this.FavoriteImageClick === true) {
                this.FavoriteImageClick = false;
                (event as Event).stopPropagation();
            }
        if (event.EngagementFullName != null) {
            this.showEngSearchList = true;
            this.showEngSearchLoader = true;
            this.engagementSearch = new SearchEngagementDto();
            this.engagementSearch.SearchKey = event.EngagementFullName.trim();
            this.engagementSearch.InstanceId = this.selectedInstance;
            this.engagementSearch.JobId = event.JobId;
            this.engagementListSubscription = this.reportService
                .SearchEngagement(this.engagementSearch)
                .subscribe((data) => {
                    this.sortedJobList = this.orderPipe.transform(data, 'JobDescription');

                    this.results = this.sortedJobList;
                    this.showSearchLoader = false;
                    if (this.results) {
                        this.OnItemSelect(this.results[0]);
                    }
                });
        } else {
            this.results = [];
            this.showEngSearchList = false;
        }
    }
    OnEngItemSelect(event) {
        if (this.FavoriteImageClick === true) {
            this.FavoriteImageClick = false;
            (event as Event).stopPropagation();
        }

        this.showEngSearchList = false;
        this.showFavouriteEngList = false;
        this.engSearchBar = event.JobDescription;
        this.JobId = event.JobId;
        this.EngagementTitle = event.JobDescription;
        this.engagementCode = event.JobCode;
        this.engagementStatus = event.JobStatus;
        this.engagementType = event.JobType;
        this.engagementServiceLine = event.ServiceLineDescription;
        this.engagementServiceCode = event.ServiceLineCode;
    }
    onFavoriteImageClick(item) {
        this.FavoriteImageClick = true;
        item.IsOldFavEngInserted = item.IsFavEngInserted;
        item.IsFavEngInserted = !item.IsFavEngInserted;

        if (item.IsFavEngInserted) {
            item.favEngSrc = favEngImageSrc.favEngImgStarfilled;
        } else {
            item.favEngSrc = favEngImageSrc.favEngImgStarOutline;
        }
    }
    WeelyOnChange(event) {
        this.weekly = this.weeklyModel == 'daily' ? false : true;
        // if (this.weekly == false) {
        //     this.includeMERABooking = false;
        //     this.includeMERABookingModel = 'no';
        // }
    }
    IncludeDummyResourcesOnChange(event) {
        this.includeDummyResources = this.includeDummyResourcesModel == 'no' ? false : true;
    }
    FSOOnChange(event) {
        this.fso = this.fsoModel == 'no' ? false : true;
    }
    IncludeDummyEngagementOnChange(event) {
        this.includeDummyEngagement = this.includeDummyEngagementModel == 'no' ? false : true;
    }
    IncludeMERABookingOnChange(event) {
        this.includeMERABooking = this.includeMERABookingModel == 'no' ? false : true;
    }
    onInstanceChange(event) {
        this.selectedResItems = [];
        this.selectedCounsellorItems = [];
        this.selectedEngItems = [];
        this.selectedEngManagerItems = [];
        this.selectedEngPartnerItems = [];
        this.selectedEngCustomerItems = [];
        this.selectedEngUltCustItems = [];
        this.selectedOthBookingItems = [];
        this.selectedOthMERABookingIdItems = [];
        this.selectedOthRequestorNameItems = [];
        this.selectedOthSubmittedbyItems = [];
        this.selectedOthRejectedbyItems = [];
        this.selectedOthApprovedbyItems = [];
        this.selectedInstance = event.value;
        let resource = new ResourceDto();
        resource.GPN = this.selectedResource.GPN;
        resource.ResourceId = this.selectedResource.ResourceId;
        resource.InstanceId = this.selectedInstance;
        resource.ResourceEmail = this.selectedResource.ResourceEmail;
        if (this.instances != undefined && this.instances.length > 0)
            this.selectedInstanceValue = this.instances.find(x => x.InstanceId == this.selectedInstance).InstanceName;
        this.sharedService
            .getUserResourceInstances(resource)
            .subscribe((data) => {
                const instanceOfUser = data;
                const selected = instanceOfUser.filter(
                    (x) => x.InstanceId === this.selectedInstance
                );
                if (selected.length !== 0) {
                    this.selectedResource.ResourceId = selected[0].ResourceId;
                } else {
                    this.resetfilterInstanceSearchBar();
                }
            });
    }
    resetfilterInstanceSearchBar() {
        this.showSearchList = false;
        this.onResourceClear();
        this.results = [];
        this.searchBar = '';
    }

    //v6
    searchUtilmateCustomer() {
        this.addFavouriteEngUltCustResults = [];
        if (this.searchUltCustBar != null) {
            if (this.searchUltCustBar.trim().length >= 2) {
                this.showFavouriteEngUltCustList = true;
                this.showSearchUltCustLoader = true;
                this.ultimateCustomerSearch = new UltimateCustomerSearchDto();
                this.ultimateCustomerSearch.CustomerDescription = this.searchUltCustBar;
                this.ultimateCustomerSearch.InstanceId = this.selectedInstance;
                this.resourceListSubscription = this.reportService
                    .SearchUltimateCustomer(this.ultimateCustomerSearch)
                    .subscribe((data) => {
                        this.sortedUltCustList = this.orderPipe.transform(
                            data,
                            'DisplayName'
                        );
                        if (this.sortedUltCustList.length > 0) {
                            this.ultimateCustomerResults = this.sortedUltCustList;

                            this.ultimateCustomerResults.forEach(aa => {
                                this.addFavouriteEngUltCustResults.push({ ID: aa.ID, Text: aa.DisplayName, Code: aa.Code, IsSelected: false })
                            });
                            if (this.addFavouriteEngUltCustResults) {
                                this.getSortedDataEngUltCust();
                            }
                            this.showSearchUltCustLoader = false;
                        } else {
                            this.ultimateCustomerResults = [];
                            this.showSearchUltCustList = false;
                            this.IsDataNotFound = true;
                            this.showSearchUltCustLoader = false;
                        }
                    });
            } else {
                this.ultimateCustomerResults = [];
                this.showSearchUltCustList = false;
            }
        } else {
            this.ultimateCustomerResults = [];
            this.showSearchUltCustList = false;
        }
    }
    closeDivEngCustomer() {
        if (this.isRemoveSelectedEngCustItems == false) {
            this.addFavouriteEngCustomerResults = [];
            this.showFavouriteEngCustomerList = false;
        } else {
            this.isRemoveSelectedEngCustItems = false;
        }
    }

    closeDivEngUltCust() {
        if (this.isRemoveSelectedResItems == false) {
            this.addFavouriteEngUltCustResults = [];
            this.showFavouriteEngUltCustList = false;
        }
        else {
            this.isRemoveSelectedResItems = false;
        }
    }


    onCheckboxChangeEngUltCust(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;
        if (checkbox.checked) {
            this.selectedEngUltCustItems.push(item);
        } else {
            this.selectedEngUltCustItems = this.selectedEngUltCustItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getSortedDataEngUltCust();
    }

    loadEngUltCustSelectedItem() {
        if (this.selectedEngUltCustItems) {
            if (this.selectedEngUltCustItems.length > 0) {
                this.showFavouriteEngUltCustList = true;
                this.getSortedDataEngUltCust();
            }
        }
    }
    private getSortedDataEngUltCust() {
        this.selectedEngUltCustItems.forEach(obj => {
            if (this.addFavouriteEngUltCustResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteEngUltCustResults = this.addFavouriteEngUltCustResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteEngUltCustResults.push(obj);
        });

        this.addFavouriteEngUltCustResults.forEach(obj => {
            obj.IsSelected = this.selectedEngUltCustItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedEngUltCustItems) {
            var uniqueData = this.addFavouriteEngUltCustResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteEngUltCustResults = arr;
            this.showFavouriteEngUltCustList = true;
            // this.reportdata.resource = this.selectedEngUltCustItems;
        }
    }

    isSelectedEngUltCust(item: ReportVM): boolean {
        return this.selectedEngUltCustItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    resetfilterSearchUltCustSearchBar() {
        // this.showSearchUltCustList = false;
        // this.onUltimateCustomerClear();
        this.searchUltCustBar = '';
    }
    onUltimateCustomerClear() {
        this.searchUltCustBar = '';
        this.ultimateCustomerResults = [];
        this.ultimateCustomerCode = '';
        this.ultimateCustomerName = '';
        this.ultimateCustomerID = 0;
        this.selectedEngUltCustItems = [];
    }
    OnUltimateCustomerSelect(event) {
        this.showSearchUltCustList = false;
        this.ultimateCustomerCode = event.Code;
        this.ultimateCustomerName = event.DisplayName;
        this.ultimateCustomerID = event.ID;
        this.searchUltCustBar = this.ultimateCustomerName;
    }


    //v5
    loadEngCustomerSelectedItem() {
        if (this.selectedEngCustomerItems) {
            if (this.selectedEngCustomerItems.length > 0) {
                this.showFavouriteEngCustomerList = true;
                this.getSortedDataEngCustomer();
            }
        }
    }


    searchCustomer() {
        this.addFavouriteEngCustomerResults = [];
        if (this.searchCustomerBar != null) {
            if (this.searchCustomerBar.trim().length >= 2) {
                this.showFavouriteEngCustomerList = true;
                this.showSearchCustomerLoader = true;
                this.customerSearch = new CustomerSearchDto();
                this.customerSearch.CustomerDescription = this.searchCustomerBar;
                this.customerSearch.InstanceId = this.selectedInstance;
                this.resourceListSubscription = this.reportService
                    .SearchCustomer(this.customerSearch)
                    .subscribe((data) => {
                        this.sortedCustomerList = this.orderPipe.transform(
                            data,
                            'ClientName'
                        );
                        if (this.sortedCustomerList.length > 0) {
                            this.customerResults = this.sortedCustomerList;
                            //v5
                            this.customerResults.forEach(aa => {
                                this.addFavouriteEngCustomerResults.push({ ID: aa.ClientId, Text: aa.ClientName, Code: aa.ClientNumber, IsSelected: false })
                            });
                            if (this.addFavouriteEngCustomerResults) {
                                this.getSortedDataEngCustomer();
                            }
                            this.showSearchCustomerLoader = false;
                        } else {
                            this.customerResults = [];
                            this.showSearchCustomerLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.customerResults = [];
                //  this.showSearchCustomerList = false;
            }
        } else {
            this.customerResults = [];
            //this.showSearchCustomerList = false;
        }
    }

    onCheckboxChangeEngCustomer(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedEngCustomerItems.push(item);
        } else {
            this.selectedEngCustomerItems = this.selectedEngCustomerItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getSortedDataEngCustomer();
    }

    private getSortedDataEngCustomer() {
        this.selectedEngCustomerItems.forEach(obj => {
            if (this.addFavouriteEngCustomerResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteEngCustomerResults = this.addFavouriteEngCustomerResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteEngCustomerResults.push(obj);
        });

        this.addFavouriteEngCustomerResults.forEach(obj => {
            obj.IsSelected = this.selectedEngCustomerItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedEngCustomerItems) {
            var uniqueData = this.addFavouriteEngCustomerResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteEngCustomerResults = arr;
            this.showFavouriteEngCustomerList = true;
            // this.reportdata.resource = this.selectedEngCustomerItems;
        }
    }

    isSelectedEngCustomer(item: ReportVM): boolean {
        return this.selectedEngCustomerItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    resetfilterSearchCustomerSearchBar() {
        this.searchCustomerBar = '';
        // this.showSearchCustomerList = false;
        // this.onCustomerClear();
    }
    onCustomerClear() {
        this.searchCustomerBar = '';
        this.customerResults = [];
        this.customerNumber = '';
        this.customerName = '';
        this.customerId = 0;
        this.selectedEngCustomerItems = [];
    }
    OnCustomerSelect(event) {
        this.showSearchCustomerList = false;
        this.customerNumber = event.ClientNumber;
        this.customerName = event.ClientName;
        this.searchCustomerBar = event.ClientName;
        this.customerId = event.ClientId;
    }

    closeDiv() {
        if (this.isRemoveSelectedResItems == false) {
            this.addFavouriteResResults = [];
            this.showFavouriteResList = false;
        } else {
            this.isRemoveSelectedResItems = false;
        }
        this.IsDataNotFound = false;
    }



    // private favoriteimgClickHandler(event: any) {
    //     if (!!event.target.src) {
    //         var parts = event.target.src.split('/');
    //         var img = parts[parts.length - 1];

    //         var a = favEngImageSrc.favEngImgStarOutline.split('/');
    //         var ImgStarOutline = a[a.length - 1];

    //         var b = favEngImageSrc.favEngImgStarfilled.split('/');
    //         var ImgStarfilled = b[b.length - 1];

    //         // if((event.target.src === favEngImageSrc.favEngImgStarOutline) || (event.target.src === favEngImageSrc.favEngImgStarfilled))
    //         if (img === ImgStarOutline || img === ImgStarfilled) {
    //             this.isClickonFavEngStart = true;
    //             this.outClickCount = 0;
    //         } else {
    //             this.isClickonFavEngStart = false;
    //             if (this.outClickCount == 0) {
    //                 this.outClickCount++;
    //             }
    //         }
    //     } else {
    //         if (this.isClickonFavEngStart) {
    //             if (this.outClickCount == 0) {
    //                 this.outClickCount++;
    //                 this.getAllSelectedfavEngagement();
    //             }
    //         }
    //     }
    // }


    private AddFavouriteEngagement(arr): void {
        this.engagementService.addFavouriteJobs(arr).subscribe((data) => {
            this.showEngSearchList = false;
            this.showFavouriteEngList = false;
            this.isFavEngONClick = true;
            this.engSearchBar = '';
        });
    }
    // v5
    searchEngPartner() {
        this.addFavouriteEngPartnerResults = [];
        if (this.searchEngPartnerBar != null) {
            if (this.searchEngPartnerBar.trim().length >= 2) {
                this.showFavouriteEngPartnerList = true;
                this.showSearchEngPartnerLoader = true;
                this.engPartnerSearch = new SearchResourceDto();
                this.engPartnerSearch.SearchKey = this.searchEngPartnerBar.trim();
                this.engPartnerSearch.ResourceId = 0;
                this.engPartnerSearch.InstanceId = this.selectedInstance;
                this.engPartnerSearch.ResourceSource = 'EP';
                this.resourceListSubscription = this.reportService
                    .SearchResource(this.engPartnerSearch)
                    .subscribe((data) => {
                        this.sortedEngPartnerList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedEngPartnerList.length > 0) {
                            this.engPartnerResults = this.sortedEngPartnerList;
                            //v4
                         
                            this.engPartnerResults.forEach(aa => {
                                this.addFavouriteEngPartnerResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.GPN, IsSelected: false })
                            });
                            if (this.addFavouriteEngPartnerResults) {
                                this.getSortedDataEngPartner();
                            }
                            this.showSearchEngPartnerLoader = false;
                        } else {
                            this.engPartnerResults = [];
                            this.showSearchEngPartnerList = false;
                            this.IsDataNotFound = true;
                            this.showSearchEngPartnerLoader = false;
                        }
                    });
            } else {
                this.engPartnerResults = [];
                this.showSearchEngPartnerList = false;
            }
        } else {
            this.engPartnerResults = [];
            this.showSearchEngPartnerList = false;
        }
    }

    loadEngPartnerSelectedItem() {
        if (this.selectedEngPartnerItems) {
            if (this.selectedEngPartnerItems.length > 0) {
                this.showFavouriteEngPartnerList = true;
                this.getSortedDataEngPartner();
            }
        }
    }

    closeDivEngPartner() {
        if (this.isRemoveSelectedEngPatnerItems == false) {
            this.addFavouriteEngPartnerResults = [];
            this.showFavouriteEngPartnerList = false;
        } else {
            this.isRemoveSelectedEngPatnerItems = false;
        }
        this.IsDataNotFound = false;
    }

    onCheckboxChangeEngPartner(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedEngPartnerItems.push(item);
        } else {
            this.selectedEngPartnerItems = this.selectedEngPartnerItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getSortedDataEngPartner();
    }

    private getSortedDataEngPartner() {
        this.selectedEngPartnerItems.forEach(obj => {
            if (this.addFavouriteEngPartnerResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteEngPartnerResults = this.addFavouriteEngPartnerResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteEngPartnerResults.push(obj);
        });

        this.addFavouriteEngPartnerResults.forEach(obj => {
            obj.IsSelected = this.selectedEngPartnerItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedEngPartnerItems) {
            var uniqueData = this.addFavouriteEngPartnerResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteEngPartnerResults = arr;
            this.showFavouriteEngPartnerList = true;
        }
    }

    isSelectedEngPartner(item: ReportVM): boolean {
        return this.selectedEngPartnerItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    // OnEngPartnerSelect(event) {
    //     this.showSearchEngPartnerList = false;
    //     this.engPartnerId = event.ResourceId;
    //     this.engPartnerGPN = event.GPN;
    //     this.engPartnerEmail = event.ResourceEmail;
    //     this.engPartnerName = event.ResourceName;
    //     this.selectedEngPartner = event;
    //     this.searchEngPartnerBar = event.ResourceName;
    //     if (this.selectedEngPartner.ResourceEmail == this.user.Email) {
    //         this.individualService
    //             .getProfilePhoto(this.selectedEngPartner.ResourceEmail)
    //             .subscribe((photoUrl) => {
    //                 this.selectedEngPartner.ResourcePhotoUrl = photoUrl;
    //             });
    //     }
    // }

    resetfilterEngPartnerSearchBar() {
        this.searchEngPartnerBar = '';
        // this.showFavouriteEngPartnerList = false;
        // this.onEngPartnerClear();
    }
    onEngPartnerClear() {
        this.searchEngPartnerBar = '';
        this.engPartnerResults = [];

        this.engPartnerId = 0;
        this.engPartnerGPN = '';
        this.engPartnerEmail = '';
        this.engPartnerName = '';
        this.selectedEngPartner = new SearchResourceResultDto;
        this.selectedEngPartnerItems = [];
    }

    //v4
    searchEngManager() {
        this.addFavouriteEngManagerResults = [];

        if (this.searchEngManagerBar != null) {
            if (this.searchEngManagerBar.trim().length >= 2) {
                this.showFavouriteEngManagerList = true;
                this.showSearchEngManagerLoader = true;
                this.engManagerSearch = new SearchResourceDto();
                this.engManagerSearch.SearchKey = this.searchEngManagerBar.trim();
                this.engManagerSearch.ResourceId = 0;
                this.engManagerSearch.InstanceId = this.selectedInstance;
                this.engManagerSearch.ResourceSource = 'EM';
                this.resourceListSubscription = this.reportService
                    .SearchResource(this.engManagerSearch)
                    .subscribe((data) => {
                        this.sortedEngManagerList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedEngManagerList.length > 0) {
                            this.engManagerResults = this.sortedEngManagerList;
                            //v4

                            this.engManagerResults.forEach(aa => {
                                this.addFavouriteEngManagerResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.GPN, IsSelected: false })
                            });
                            if (this.addFavouriteEngManagerResults) {
                                this.getSortedDataEngManager();
                            }
                            this.showSearchEngManagerLoader = false;
                        } else {
                            this.engManagerResults = [];
                            this.addFavouriteEngManagerResults = [];
                            this.showSearchEngManagerList = false;
                            this.showSearchEngManagerLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.engManagerResults = [];
                this.showSearchEngManagerList = false;
            }
        } else {
            this.engManagerResults = [];
            this.showSearchEngManagerList = false;
        }
    }

    loadEngManagerSelectedItem() {
        if (this.selectedEngManagerItems) {
            if (this.selectedEngManagerItems.length > 0) {
                this.showFavouriteEngManagerList = true;
                this.getSortedDataEngManager();
            }
        }
    }

    closeDivEngManager() {
        if (this.isRemoveSelectedEngMangerItems == false) {
            this.addFavouriteEngManagerResults = [];
            this.showFavouriteEngManagerList = false;
        } else {
            this.isRemoveSelectedEngMangerItems = false;
        }
        this.IsDataNotFound = false;
    }

    onCheckboxChangeEngManager(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedEngManagerItems.push(item);
        } else {
            this.selectedEngManagerItems = this.selectedEngManagerItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getSortedDataEngManager();
    }

    private getSortedDataEngManager() {
        this.selectedEngManagerItems.forEach(obj => {
            if (this.addFavouriteEngManagerResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteEngManagerResults = this.addFavouriteEngManagerResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteEngManagerResults.push(obj);
        });

        this.addFavouriteEngManagerResults.forEach(obj => {
            obj.IsSelected = this.selectedEngManagerItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedEngManagerItems) {
            var uniqueData = this.addFavouriteEngManagerResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteEngManagerResults = arr;
            this.showFavouriteEngManagerList = true;
        }
    }

    isSelectedEngManager(item: ReportVM): boolean {
        return this.selectedEngManagerItems.some(selectedItem => selectedItem.ID === item.ID);
    }


    OnEngManagerSelect(event) {
        this.showSearchEngManagerList = false;
        this.engManagerId = event.ResourceId;
        this.engManagerGPN = event.GPN;
        this.engManagerEmail = event.ResourceEmail;
        this.engManagerName = event.ResourceName;
        this.selectedEngManager = event;
        this.searchEngManagerBar = event.ResourceName;
        if (this.selectedEngManager.ResourceEmail == this.user.Email) {
            this.individualService
                .getProfilePhoto(this.selectedEngManager.ResourceEmail)
                .subscribe((photoUrl) => {
                    this.selectedEngManager.ResourcePhotoUrl = photoUrl;
                });
        }
    }

    resetfilterEngManagerSearchBar() {
        // this.showSearchEngManagerList = false;
        // this.onEngManagerClear();
        this.searchEngManagerBar = '';
    }
    onEngManagerClear() {
        this.searchEngManagerBar = '';
        this.engManagerResults = [];

        this.engManagerId = 0;
        this.engManagerGPN = '';
        this.engManagerEmail = '';
        this.engManagerName = '';
        this.selectedEngManager = new SearchResourceResultDto;
        this.selectedEngManagerItems = [];
    }

    splitString(input: string, delimiter: string): string[] {
        return input.split(delimiter).map(part => part.trim());
    }
    //v2  Councellor
    searchCouncellor() {
        if (this.searchCouncellorBar != null) {
            if (this.searchCouncellorBar.trim().length >= 2) {
                this.showSearchCouncellorLoader = true;
                this.addFavouriteCounsellorResults = [];
                this.showSearchList = false;
                this.showFavouriteCounsellorList = true;
                this.councellorSearch = new SearchCouncellorDto();
                this.councellorSearch.SearchKey = this.searchCouncellorBar.trim();
                this.councellorSearch.ResourceId = 0;
                this.councellorSearch.InstanceId = this.selectedInstance;
                this.resourceListSubscription = this.reportService
                    .SearchCouncellor(this.councellorSearch)
                    .subscribe((data) => {
                        this.sortedCouncellorList = this.orderPipe.transform(
                            data,
                            'CouncellorName'
                        );
                        if (this.sortedCouncellorList.length > 0) {
                            this.resultsCouncellor = this.sortedCouncellorList;

                            this.resultsCouncellor.forEach(aa => {
                                //let str = `${aa[0]}-${aa[1]}`;
                                this.addFavouriteCounsellorResults.push({ ID: 0, Text: aa.CouncellorName, Code: aa.CouncellorName, IsSelected: false })
                            });

                            if (this.addFavouriteCounsellorResults) {
                                this.getSortedDataCounsellor();
                            }

                            this.showSearchCouncellorLoader = false;
                        } else {
                            this.resultsCouncellor = [];

                            this.showSearchCouncellorList = false;
                            this.showSearchCouncellorLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.resultsCouncellor = [];
                this.showSearchCouncellorLoader = false;
            }
        } else {
            this.resultsCouncellor = [];
            this.showSearchCouncellorLoader = false;
        }
    }

    loadCounsellorSelectedItem() {
        if (this.selectedCounsellorItems) {
            if (this.selectedCounsellorItems.length > 0) {
                this.showSearchList = false;
                this.showFavouriteCounsellorList = true;
                this.getSortedDataCounsellor();
            }
        }
    }

    closeDivCounsellor() {

        if (this.isRemoveSelectedCouncellorItems == false) {
            this.addFavouriteCounsellorResults = [];
            this.showFavouriteCounsellorList = false;
        } else {
            this.isRemoveSelectedCouncellorItems = false;
        }
        this.IsDataNotFound = false;
    }

    onCheckboxChangeCounsellor(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedCounsellorItems.push(item);
        } else {
            this.selectedCounsellorItems = this.selectedCounsellorItems.filter(selectedItem => selectedItem.Code !== item.Code);
        }
        this.getSortedDataCounsellor();
    }

    private getSortedDataCounsellor() {
        this.selectedCounsellorItems.forEach(obj => {
            if (this.addFavouriteCounsellorResults.some(a => a.Code == obj.Code)) {
                this.addFavouriteCounsellorResults = this.addFavouriteCounsellorResults.filter(selectedItem => selectedItem.Code !== obj.Code);
            }

            this.addFavouriteCounsellorResults.push(obj);
        });

        this.addFavouriteCounsellorResults.forEach(obj => {
            obj.IsSelected = this.selectedCounsellorItems.some(a => a.Code == obj.Code);
        });

        if (this.selectedCounsellorItems) {
            var uniqueData = this.addFavouriteCounsellorResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteCounsellorResults = arr;
            this.showFavouriteCounsellorList = true;
        }
    }

    isSelectedCounsellor(item: ReportVM): boolean {
        return this.selectedCounsellorItems.some(selectedItem => selectedItem.Code === item.Code);
    }

    OnCouncellorSelect(event) {
        this.showSearchCouncellorList = false;
        this.searchCouncellorBar = event.CouncellorName;
    }
    resetfilterCouncellorSearchBar() {
        this.searchCouncellorBar = '';
        // this.showSearchCouncellorList = false;
        // this.onCouncellorClear();
    }
    onCouncellorClear() {
        this.searchCouncellorBar = '';
        this.resultsCouncellor = [];
        this.selectedCounsellorItems = [];
    }
    showHideControls() {
        switch (this.ReportMainData.reportCode) {
            case Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE:
            case Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE:
                if (this.ReportMainData.reportCode == Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE)
                    this.selectedTabVal = "Engagement";
                else
                    this.selectedTabVal = 'Resource';
                this.showTabs = true;
                this.showResourceTab = true;
                this.showEngagementTab = true;
                this.showOtherTab = true;
                this.showWeekly = true;
                this.showIncludeMERABookings = true;
                this.showResResource = true;
                this.showResIncludeDummyResources = true;
                this.showResServiceLine = true;
                this.showResSubServiceLine = true;
                this.showResCompetency = true;
                this.showResCountry = true;
                this.showResCostCenter = true;
                this.showResCompanyCode = true;
                this.showResEconomicLocation = true;
                this.showResOfficeLocation = true;
                this.showResGrade = true;
                this.showResRank = true;
                this.showResEmployeeStatus = true;
                this.showResEmployeeType = true;
                this.showResEmployeeDepartment = true;
                this.showResGDSRegionAlignment = true;
                this.showResCounsellor = true;
                this.showEngEngagement = true;
                this.showEngIncludeDummyEngagement = true;
                this.showEngEngagementType = true;
                this.showEngEngagementSubType = true;
                this.showEngServiceLine = true;
                this.showEngSubServiceLine = true;
                this.showEngEngagementCompetency = true;
                this.showEngEngagementRegion = true;
                this.showEngEngagementCountry = true;
                this.showEngEngagementCostCenter = true;
                this.showEngEngagementStatus = true;
                this.showEngCustomerIndustry = true;
             
                if(!this.user.IsMultiInstance && this.user.RoleInstanceId === 4){
                    this.showEngCustomerPriorityStatus = false;
                } else {
                    this.showEngCustomerPriorityStatus = true;
                }
                
                this.showEngEngagementManager = true;
                this.showEngEngagementPartner = true;
                this.showEngCustomer = true;
                this.showEngUltCust = true;
                this.showOthBookingCategory = true;
                break;
            case Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE:
                this.selectedTabVal = 'Resource';
                this.showTabs = false;
                this.showResourceTab = true;
                this.showEngagementTab = false;
                this.showOtherTab = false;
                this.showWeekly = true;
                this.showIncludeMERABookings = true;
                this.showResResource = true;
                this.showResServiceLine = true;
                this.showResSubServiceLine = true;
                this.showResCountry = true;
                this.showResGrade = true;
                this.showResCostCenter = true;
                this.showResCompanyCode = true;
                this.showResCompetency = true;
                this.showResEconomicLocation = true;
                this.showResOfficeLocation = true;
                this.showResCounsellor = true;
                this.showResEmployeeDepartment = true;
                this.showResGDSRegionAlignment = true;
                this.showResAvailability = true;
                break;
            case Report.ReportCode.AUDITTRAIL_REPORTCODE:
                this.selectedTabVal = 'Resource';
                this.showTabs = true;
                this.showResourceTab = true;
                this.showEngagementTab = true;
                this.showOtherTab = true;
                this.showResResource = true;
                this.showResCountry = true;
                this.showResGrade = true;
                this.showResServiceLine = true;
                this.showResSubServiceLine = true;
                this.showResCostCenter = true;
                this.showResCompanyCode = true;
                this.showResEconomicLocation = true;
                this.showResOfficeLocation = true;
                this.showResGDSRegionAlignment = true;
                this.showResEmployeeDepartment = true;
                this.showResCounsellor = true;
                this.showEngEngagement = true;
                this.showEngEngagementStatus = true;
                this.showEngEngagementType = true;
                this.showEngEngagementSubType = true;
                this.showEngEngagementCompetency = true;
                this.showEngEngagementCountry = true;
                this.showEngEngagementManager = true;
                this.showEngEngagementPartner = true;
                this.showEngEngagementRegion = true;
                this.showEngCustomer = true;
                this.showOtherBookingTypes = true;
                this.showOtherBookings = true;
                this.showOtherMERAActions = true;
                this.showOtherMERABookings = true;
                this.showOtherRequestors = true;
                this.showOtherRequestorModes = true;
                this.showOtherStatus = true;
                this.showOtherStatusInformation = true;
                this.showOtherSubmittedBy = true;
                this.showOtherSubmittedOn = true;
                this.showOtherApprovedBy = true;
                this.showOtherApprovedOn = true;
                this.showOtherRejectedBy = true;
                this.showOtherRejectedOn = true;
                break;
            case Report.ReportCode.ADOPTION_REPORTCODE:
                this.selectedTabVal = 'Resource'
                this.showTabs = false;
                this.showResourceTab = true;
                this.showEngagementTab = false;
                this.showOtherTab = false;
                this.showResResource = true;
                this.showResEmployeeStatus = true;
                this.showResCountry = true;
                this.showResServiceLine = true;
                this.showResSubServiceLine = true;
                this.showResCostCenter = true;
                this.showResCompanyCode = true;
                this.showResCompetency = true;
                this.showResEmployeeDepartment = true;
                this.showResRank = true;
                this.showResGrade = true;
                this.showResEmployeeType = true;
                this.showResOfficeLocation = true;
                this.showResEconomicLocation = true;
                this.showResGDSRegionAlignment = true;
                this.showResCounsellor = true;
                this.showResRegion = true;
                this.showResFSO = true;
                this.showResSubRegion = true
                break;
        }
    }
    getDefaultPeriodSettings() {
        this.defaultStartDate = this.getFirstDateOfWeek(this.todaysDate);
        let searchStart: Date;
        let searchEnd: Date;

        if (this.ReportMainData.reportCode == Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE) {
            //Default date is current week saturday to 24 weeks future
            this.defaultEndDate = this.getFirstDateOfWeek(this.todaysDate);
            this.defaultEndDate.setDate(this.defaultEndDate.getDate() + 24 * 7);

            // Subtract 24 weeks from current date. If the date is > 1st july previous year 
            // 	then 1st July previouse year
            // else
            // 	pass 24 weeks from current date.
            searchStart = this.getFirstDateOfWeek(this.todaysDate);
            searchStart.setDate(searchStart.getDate() - 24 * 7)
            if (searchStart > new Date(this.todaysDate.getFullYear() - 1, 6, 1)) {
                searchStart = new Date(this.todaysDate.getFullYear() - 1, 6, 1);
            }
        }
        else {
            //Default date is current week saturday to 13 weeks future
            this.defaultEndDate = this.getFirstDateOfWeek(this.todaysDate);
            this.defaultEndDate.setDate(this.defaultEndDate.getDate() + 13 * 7);

            // Subtract 52 weeks from current date. If the date is > 1st july previous year 
            // 	then 1st July previouse year
            // else
            // 	pass 52 weeks from current date.
            searchStart = this.getFirstDateOfWeek(this.todaysDate);
            searchStart.setDate(searchStart.getDate() - 52 * 7)

            if (searchStart > new Date(this.todaysDate.getFullYear() - 1, 6, 1)) {
                searchStart = new Date(this.todaysDate.getFullYear() - 1, 6, 1);
            }
        }
        if (this.defaultStartDate != null)
            this.defaultStartDate = new Date(
                this.defaultStartDate.getFullYear(),
                this.defaultStartDate.getMonth(),
                this.defaultStartDate.getDate(),
                0,
                0,
                0
            );

        if (this.defaultEndDate != null)
            this.defaultEndDate = new Date(
                this.defaultEndDate.getFullYear(),
                this.defaultEndDate.getMonth(),
                this.defaultEndDate.getDate(),
                0,
                0,
                0
            );
        searchEnd = this.getFirstDateOfWeek(this.todaysDate);
        searchEnd.setDate(searchEnd.getDate() + 52 * 7)
        this.startWith = this.getFirstDateOfWeek(searchStart);
        
        this.endWith = this.getFirstDateOfWeek(searchEnd);
        
        if (this.ReportMainData.reportCode == Report.ReportCode.ADOPTION_REPORTCODE) {
            this.endWith = this.todaysDate;
            this.defaultStartDate.setDate(this.defaultStartDate.getDate() - 6 * 7);
            this.defaultEndDate = this.todaysDate;
        }

        this.startWith.setMinutes(
            this.startWith.getMinutes() - this.startWith.getTimezoneOffset()
        );
        this.endWith.setMinutes(
            this.endWith.getMinutes() - this.endWith.getTimezoneOffset()
        );
        
        if (this.ReportMainData.reportCode == Report.ReportCode.AUDITTRAIL_REPORTCODE) {
            this.submittedonstartWith = this.getFirstDateOfWeek(searchStart);
            this.submittedonendWith = this.getFirstDateOfWeek(searchEnd);
            this.approvedonstartWith = this.getFirstDateOfWeek(searchStart);
            this.approvedonendWith = this.getFirstDateOfWeek(searchEnd);
            this.rejectedonstartWith = this.getFirstDateOfWeek(searchStart);
            this.rejectedonendWith = this.getFirstDateOfWeek(searchEnd);

            this.submittedonstartWith.setMinutes(
                this.submittedonstartWith.getMinutes() - this.submittedonstartWith.getTimezoneOffset()
            );
            this.submittedonendWith.setMinutes(
                this.submittedonendWith.getMinutes() - this.submittedonendWith.getTimezoneOffset()
            );
            this.approvedonstartWith.setMinutes(
                this.approvedonstartWith.getMinutes() - this.approvedonstartWith.getTimezoneOffset()
            );
            this.approvedonendWith.setMinutes(
                this.approvedonendWith.getMinutes() - this.approvedonendWith.getTimezoneOffset()
            );
            this.rejectedonstartWith.setMinutes(
                this.rejectedonstartWith.getMinutes() - this.rejectedonstartWith.getTimezoneOffset()
            );
            this.rejectedonendWith.setMinutes(
                this.rejectedonendWith.getMinutes() - this.rejectedonendWith.getTimezoneOffset()
            );
        }
    }
    getFirstDateOfWeek(anyDateOfWeek: Date): Date {
        // date.getDay() RETURNS Week Day Index: SUN 0, MON 1, TUE 2, WED 3, THU 4, FRI 5, SAT 6.
        let date = new Date(anyDateOfWeek);
        let firstDayOfWeekIndex: number = 6; //Week Day Index: SUN 0, MON 1, TUE 2, WED 3, THU 4, FRI 5, SAT 6.
        let daysToShiftBack = (7 + (date.getDay() - firstDayOfWeekIndex)) % 7;
        let firstDateOfWeek = new Date(
            date.setDate(date.getDate() - daysToShiftBack)
        );
        return firstDateOfWeek;
    }
    onSubmittedOnReportStartDateChange(event: any) {
        this.submittedOnStartDate = this.submittedOnrange.get('start').value;
        this.submittedOnEndDate = null;
    }
    onSubmittedOnReportEndDateChange(event: any) {
        this.submittedOnEndDate = this.submittedOnrange.get('end').value;
        if (event.value != null) {
            if (this.submittedOnEndDate != null) {
                this.submittedOnStartDate = new Date(this.submittedOnStartDate);
                this.submittedOnEndDate = new Date(this.submittedOnEndDate);
            }
        }
    }
    resetSubmittedOnfilter(event) {
        event.stopPropagation();
        event.preventDefault();
        this.submittedOnrange.setValue({
            start: null,
            end: null,
        });
        this.submittedOnStartDate = null;
        this.submittedOnEndDate = null;
    }
    OnSubmittedOnClosedDatePicker() {
        if (this.submittedOnStartDate != null && this.submittedOnEndDate == null) {
            setTimeout(() => {
                this.submittedOnStartDate = null;
                this.submittedOnEndDate = null;
                this.submittedOnrange.setValue({
                    start: null,
                    end: null,
                });
            }, 3000);
        }
    }
    onApprovedOnReportStartDateChange(event: any) {
        this.approvedOnStartDate = this.approvedOnrange.get('start').value;
        this.approvedOnEndDate = null;
    }
    onApprovedOnReportEndDateChange(event: any) {
        this.approvedOnEndDate = this.approvedOnrange.get('end').value;
        if (event.value != null) {
            if (this.approvedOnEndDate != null) {
                this.approvedOnStartDate = new Date(this.approvedOnStartDate);
                this.approvedOnEndDate = new Date(this.approvedOnEndDate);
            }
        }
    }
    resetApprovedOnfilter(event) {
        event.stopPropagation();
        event.preventDefault();
        this.approvedOnrange.setValue({
            start: null,
            end: null,
        });
        this.approvedOnStartDate = null;
        this.approvedOnEndDate = null;
    }
    OnApprovedOnClosedDatePicker() {
        if (this.approvedOnStartDate != null && this.approvedOnEndDate == null) {
            setTimeout(() => {
                this.approvedOnStartDate = null;
                this.approvedOnEndDate = null;
                this.approvedOnrange.setValue({
                    start: null,
                    end: null,
                });
            }, 3000);
        }
    }
    onRejectedOnReportStartDateChange(event: any) {
        this.rejectedOnStartDate = this.rejectedOnrange.get('start').value;
        this.rejectedOnEndDate = null;
    }
    onRejectedOnReportEndDateChange(event: any) {
        this.rejectedOnEndDate = this.rejectedOnrange.get('end').value;
        if (event.value != null) {
            if (this.rejectedOnEndDate != null) {
                this.rejectedOnStartDate = new Date(this.rejectedOnStartDate);
                this.rejectedOnEndDate = new Date(this.rejectedOnEndDate);
            }
        }
    }
    resetRejectedOnfilter(event) {
        event.stopPropagation();
        event.preventDefault();
        this.rejectedOnrange.setValue({
            start: null,
            end: null,
        });
        this.rejectedOnStartDate = null;
        this.rejectedOnEndDate = null;
    }
    OnRejectedOnClosedDatePicker() {
        if (this.rejectedOnStartDate != null && this.rejectedOnEndDate == null) {
            setTimeout(() => {
                this.rejectedOnStartDate = null;
                this.rejectedOnEndDate = null;
                this.rejectedOnrange.setValue({
                    start: null,
                    end: null,
                });
            }, 3000);
        }
    }



    //VO

    //Submittedby

    closeDivOtherSubmittedby() {
        if (this.isRemoveSelectedOthSubmittedbyItems == false) {
            this.addFavouritOthSubmittedbyResults = [];
            this.showFavouriteOthSubmittedbyList = false;
        }
        else {
            this.isRemoveSelectedOthSubmittedbyItems = false;
        }
        this.IsDataNotFound = false;
    }



    onOtherSubmittedbyCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedOthSubmittedbyItems.push(item);
        } else {
            this.selectedOthSubmittedbyItems = this.selectedOthSubmittedbyItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getOtherSubmittedbySortedData();
    }

    private getOtherSubmittedbySortedData() {
        this.selectedOthSubmittedbyItems.forEach(obj => {
            if (this.addFavouritOthSubmittedbyResults.some(a => a.ID == obj.ID)) {
                this.addFavouritOthSubmittedbyResults = this.addFavouritOthSubmittedbyResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouritOthSubmittedbyResults.push(obj);
        });

        this.addFavouritOthSubmittedbyResults.forEach(obj => {
            obj.IsSelected = this.selectedOthSubmittedbyItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedOthSubmittedbyItems) {
            var uniqueData = this.addFavouritOthSubmittedbyResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouritOthSubmittedbyResults = arr;
            this.showFavouriteOthSubmittedbyList = true;
        }

        console.log(this.selectedOthSubmittedbyItems);
    }

    isOtherSubmittedbySelected(item: ReportVM): boolean {
        return this.selectedOthSubmittedbyItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchOthSubmittedby() {
        if (this.searchBarOthSubmittedby != null) {
            this.searchBarOthSubmittedby = String(this.searchBarOthSubmittedby).trim();
            if (this.searchBarOthSubmittedby.length >= 2) {
                this.addFavouritOthSubmittedbyResults = [];
                this.showFavouriteOthSubmittedbyList = true;
                this.showSearchOthSubmittedbyLoader = true;

                this.OthSubmittedby = new SearchResourceDto();
                this.OthSubmittedby.SearchKey = String(this.searchBarOthSubmittedby).trim();
                this.OthSubmittedby.ResourceSource = 'SB';
                this.OthSubmittedby.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .SearchResource(this.OthSubmittedby)
                    .subscribe((data) => {
                        this.sortedOthSubmittedbyList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedOthSubmittedbyList.length > 0) {
                            this.results = this.sortedOthSubmittedbyList;
                            this.results.forEach(aa => {
                                this.addFavouritOthSubmittedbyResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.GPN, IsSelected: false })
                            });
                            if (this.addFavouritOthSubmittedbyResults) {
                                this.getOtherSubmittedbySortedData();
                            }
                            this.showSearchOthSubmittedbyLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouritOthSubmittedbyResults = [];
                            this.showSearchOthSubmittedbyLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarOthSubmittedby() {
        this.searchBarOthSubmittedby = '';
    }

    loadSelectedOthSubmittedbyItem() {
        if (this.selectedOthSubmittedbyItems) {
            if (this.selectedOthSubmittedbyItems.length > 0) {
                this.showFavouriteOthSubmittedbyList = true;
                this.getOtherSubmittedbySortedData();
            }
        }
    }

    //Approvedby

    closeDivOtherApprovedby() {
        if (this.isRemoveSelectedOthApprovedbyItems == false) {
            this.addFavouritOthApprovedbyResults = [];
            this.showFavouriteOthApprovedbyList = false;
        }
        else {
            this.isRemoveSelectedOthApprovedbyItems = false;
        }
        this.IsDataNotFound = false;
    }



    onOtherApprovedbyCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedOthApprovedbyItems.push(item);
        } else {
            this.selectedOthApprovedbyItems = this.selectedOthApprovedbyItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getOtherApprovedbySortedData();
    }

    private getOtherApprovedbySortedData() {
        this.selectedOthApprovedbyItems.forEach(obj => {
            if (this.addFavouritOthApprovedbyResults.some(a => a.ID == obj.ID)) {
                this.addFavouritOthApprovedbyResults = this.addFavouritOthApprovedbyResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouritOthApprovedbyResults.push(obj);
        });

        this.addFavouritOthApprovedbyResults.forEach(obj => {
            obj.IsSelected = this.selectedOthApprovedbyItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedOthApprovedbyItems) {
            var uniqueData = this.addFavouritOthApprovedbyResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouritOthApprovedbyResults = arr;
            this.showFavouriteOthApprovedbyList = true;
        }

        console.log(this.selectedOthApprovedbyItems);
    }

    isOtherApprovedbySelected(item: ReportVM): boolean {
        return this.selectedOthApprovedbyItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchOthApprovedby() {
        if (this.searchBarOthApprovedby != null) {
            this.searchBarOthApprovedby = String(this.searchBarOthApprovedby).trim();
            if (this.searchBarOthApprovedby.length >= 2) {
                this.addFavouritOthApprovedbyResults = [];
                this.showFavouriteOthApprovedbyList = true;
                this.showSearchOthApprovedbyLoader = true;

                this.OthApprovedby = new SearchResourceDto();
                this.OthApprovedby.SearchKey = String(this.searchBarOthApprovedby).trim();
                this.OthApprovedby.ResourceSource = 'AP';
                this.OthApprovedby.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .SearchResource(this.OthApprovedby)
                    .subscribe((data) => {
                        this.sortedOthApprovedbyList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedOthApprovedbyList.length > 0) {
                            this.results = this.sortedOthApprovedbyList;
                            console.log(this.results);
                            this.results.forEach(aa => {
                                this.addFavouritOthApprovedbyResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.GPN, IsSelected: false })
                            });
                            if (this.addFavouritOthApprovedbyResults) {
                                this.getOtherApprovedbySortedData();
                            }
                            this.showSearchOthApprovedbyLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouritOthApprovedbyResults = [];
                            this.showSearchOthApprovedbyLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarOthApprovedby() {
        this.searchBarOthApprovedby = '';
    }

    loadSelectedOthApprovedbyItem() {
        if (this.selectedOthApprovedbyItems) {
            if (this.selectedOthApprovedbyItems.length > 0) {
                this.showFavouriteOthApprovedbyList = true;
                this.getOtherApprovedbySortedData();
            }
        }
    }

    //Rejectedby

    closeDivOtherRejectedby() {
        if (this.isRemoveSelectedOthRejectedbyItems == false) {
            this.addFavouritOthRejectedbyResults = [];
            this.showFavouriteOthRejectedbyList = false;
        }
        else {
            this.isRemoveSelectedOthRejectedbyItems = false;
        }
        this.IsDataNotFound = false;
    }

    onOtherRejectedbyCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedOthRejectedbyItems.push(item);
        } else {
            this.selectedOthRejectedbyItems = this.selectedOthRejectedbyItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getOtherRejectedbySortedData();
    }

    private getOtherRejectedbySortedData() {
        this.selectedOthRejectedbyItems.forEach(obj => {
            if (this.addFavouritOthRejectedbyResults.some(a => a.ID == obj.ID)) {
                this.addFavouritOthRejectedbyResults = this.addFavouritOthRejectedbyResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouritOthRejectedbyResults.push(obj);
        });

        this.addFavouritOthRejectedbyResults.forEach(obj => {
            obj.IsSelected = this.selectedOthRejectedbyItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedOthRejectedbyItems) {
            var uniqueData = this.addFavouritOthRejectedbyResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouritOthRejectedbyResults = arr;
            this.showFavouriteOthRejectedbyList = true;
        }

        console.log(this.selectedOthRejectedbyItems);
    }

    isOtherRejectedbySelected(item: ReportVM): boolean {
        return this.selectedOthRejectedbyItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchOthRejectedby() {
        if (this.searchBarOthRejectedby != null) {
            this.searchBarOthRejectedby = String(this.searchBarOthRejectedby).trim();
            if (this.searchBarOthRejectedby.length >= 2) {
                this.addFavouritOthRejectedbyResults = [];
                this.showFavouriteOthRejectedbyList = true;
                this.showSearchOthRejectedbyLoader = true;

                this.OthRejectedby = new SearchResourceDto();
                this.OthRejectedby.SearchKey = String(this.searchBarOthRejectedby).trim();
                this.OthRejectedby.ResourceSource = 'RJ';
                this.OthRejectedby.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .SearchResource(this.OthRejectedby)
                    .subscribe((data) => {
                        this.sortedOthRejectedbyList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedOthRejectedbyList.length > 0) {
                            this.results = this.sortedOthRejectedbyList;
                            console.log(this.results);
                            this.results.forEach(aa => {
                                this.addFavouritOthRejectedbyResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.GPN, IsSelected: false })
                            });
                            if (this.addFavouritOthRejectedbyResults) {
                                this.getOtherRejectedbySortedData();
                            }
                            this.showSearchOthRejectedbyLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouritOthRejectedbyResults = [];
                            this.showSearchOthRejectedbyLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarOthRejectedby() {
        this.searchBarOthRejectedby = '';
    }

    loadSelectedOthRejectedbyItem() {
        if (this.selectedOthRejectedbyItems) {
            if (this.selectedOthRejectedbyItems.length > 0) {
                this.showFavouriteOthRejectedbyList = true;
                this.getOtherRejectedbySortedData();
            }
        }
    }

    // EmployeeDepartment  000

    closeDivResEmployeeDepartment() {
        if (this.isRemoveSelectedResEmployeeDepartmentItems == false) {
            this.addFavouritResEmployeeDepartmentResults = [];

            this.showFavouriteResEmployeeDepartmentList = false;
        }
        else {
            this.isRemoveSelectedResEmployeeDepartmentItems = false;
        }
        this.IsDataNotFound = false;
    }

    onResEmployeeDepartmentCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedResEmployeeDepartmentItems.push(item);
        } else {
            this.selectedResEmployeeDepartmentItems = this.selectedResEmployeeDepartmentItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getResEmployeeDepartmentSortedData();
    }

    private getResEmployeeDepartmentSortedData() {
        this.selectedResEmployeeDepartmentItems.forEach(obj => {
            if (this.addFavouritResEmployeeDepartmentResults.some(a => a.ID == obj.ID)) {
                this.addFavouritResEmployeeDepartmentResults = this.addFavouritResEmployeeDepartmentResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouritResEmployeeDepartmentResults.push(obj);
        });

        this.addFavouritResEmployeeDepartmentResults.forEach(obj => {
            obj.IsSelected = this.selectedResEmployeeDepartmentItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedResEmployeeDepartmentItems) {
            var uniqueData = this.addFavouritResEmployeeDepartmentResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouritResEmployeeDepartmentResults = arr;
            this.showFavouriteResEmployeeDepartmentList = true;
        }

        console.log(this.selectedResEmployeeDepartmentItems);
    }

    isResEmployeeDepartmentSelected(item: ReportVM): boolean {
        return this.selectedResEmployeeDepartmentItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchResEmployeeDepartment() {
        if (this.searchBarResEmployeeDepartment != null) {
            this.searchBarResEmployeeDepartment = String(this.searchBarResEmployeeDepartment).trim();
            if (this.searchBarResEmployeeDepartment.length >= 2) {
                // debugger;
                this.addFavouritResEmployeeDepartmentResults = [];
                this.showFavouriteResEmployeeDepartmentList = true;
                this.showSearchResEmployeeDepartmentLoader = true;

                this.resEmployeeDepartment = new EmployeeDepartmentSearchDto();
                this.resEmployeeDepartment.SearchKey = String(this.searchBarResEmployeeDepartment).trim();
                this.resEmployeeDepartment.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .GetResourceDepartment(this.resEmployeeDepartment)
                    .subscribe((data) => {
                        this.sortedResEmployeeDepartmentList = this.orderPipe.transform(
                            data
                        );
                        if (this.sortedResEmployeeDepartmentList.length > 0) {
                            this.results = this.sortedResEmployeeDepartmentList;

                            this.results.forEach(aa => {
                                this.addFavouritResEmployeeDepartmentResults.push({ ID: aa.ID, Text: aa.DisplayName, Code: aa.Code, IsSelected: false })
                            });
                            if (this.addFavouritResEmployeeDepartmentResults) {
                                this.getResEmployeeDepartmentSortedData();
                            }
                            this.showSearchResEmployeeDepartmentLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouritResEmployeeDepartmentResults = [];
                            this.showSearchResEmployeeDepartmentLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarResEmployeeDepartment() {
        this.searchBarResEmployeeDepartment = '';
    }

    loadSelectedResEmployeeDepartmentItem() {
        if (this.selectedResEmployeeDepartmentItems) {
            if (this.selectedResEmployeeDepartmentItems.length > 0) {
                this.showFavouriteResEmployeeDepartmentList = true;
                this.getResEmployeeDepartmentSortedData();
            }
        }
    }


    //RequestName

    closeDivOtherRequestorName() {
        if (this.isRemoveSelectedOthRequestorNameItems == false) {
            this.addFavouritOthRequestorNameResults = [];
            this.showFavouriteOthRequestorNameList = false;
        }
        else {
            this.isRemoveSelectedOthRequestorNameItems = false;
        }
        this.IsDataNotFound = false;
    }

    onOtherRequestorNameCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedOthRequestorNameItems.push(item);
        } else {
            this.selectedOthRequestorNameItems = this.selectedOthRequestorNameItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getOtherRequestorNameSortedData();
    }

    private getOtherRequestorNameSortedData() {
        this.selectedOthRequestorNameItems.forEach(obj => {
            if (this.addFavouritOthRequestorNameResults.some(a => a.ID == obj.ID)) {
                this.addFavouritOthRequestorNameResults = this.addFavouritOthRequestorNameResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouritOthRequestorNameResults.push(obj);
        });

        this.addFavouritOthRequestorNameResults.forEach(obj => {
            obj.IsSelected = this.selectedOthRequestorNameItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedOthRequestorNameItems) {
            var uniqueData = this.addFavouritOthRequestorNameResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouritOthRequestorNameResults = arr;
            this.showFavouriteOthRequestorNameList = true;
        }

        console.log(this.selectedOthRequestorNameItems);
    }

    isOtherRequestorNameSelected(item: ReportVM): boolean {
        return this.selectedOthRequestorNameItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchOthRequestorName() {
        if (this.searchBarOthRequestorName != null) {
            this.searchBarOthRequestorName = String(this.searchBarOthRequestorName).trim();
            if (this.searchBarOthRequestorName.length >= 2) {
                this.addFavouritOthRequestorNameResults = [];
                this.showFavouriteOthRequestorNameList = true;
                this.showSearchOthRequestorNameLoader = true;

                this.OthRequestorName = new SearchResourceDto();
                this.OthRequestorName.SearchKey = String(this.searchBarOthRequestorName).trim();
                this.OthRequestorName.ResourceSource = 'RQ';
                this.OthRequestorName.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .SearchResource(this.OthRequestorName)
                    .subscribe((data) => {
                        this.sortedOthRequestorNameList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedOthRequestorNameList.length > 0) {
                            this.results = this.sortedOthRequestorNameList;

                            this.results.forEach(aa => {
                                this.addFavouritOthRequestorNameResults.push({ ID: aa.ResourceId, Text: aa.ResourceName, Code: aa.GPN, IsSelected: false })
                            });
                            if (this.addFavouritOthRequestorNameResults) {
                                this.getOtherRequestorNameSortedData();
                            }
                            this.showSearchOthRequestorNameLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouritOthRequestorNameResults = [];
                            this.showSearchOthRequestorNameLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarOthRequestorName() {
        this.searchBarOthRequestorName = '';
    }

    loadSelectedOthRequestorNameItem() {
        if (this.selectedOthRequestorNameItems) {
            if (this.selectedOthRequestorNameItems.length > 0) {
                this.showFavouriteOthRequestorNameList = true;
                this.getOtherRequestorNameSortedData();
            }
        }
    }


    // MERABookingId
    closeDivOtherMERABookings() {
        if (this.isRemoveSelectedOthMERABookingIdItems == false) {
            this.addFavouriteOthMERABookingIdResults = [];
            this.showFavouriteOthMERABookingIdList = false;
        }
        else {
            this.isRemoveSelectedOthMERABookingIdItems = false;
        }
        this.IsDataNotFound = false;
    }

    onOtherMERABookingsCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedOthMERABookingIdItems.push(item);
        } else {
            this.selectedOthMERABookingIdItems = this.selectedOthMERABookingIdItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getOtherMERABookingsIdSortedData();
    }

    private getOtherMERABookingsIdSortedData() {
        this.selectedOthMERABookingIdItems.forEach(obj => {
            if (this.addFavouriteOthMERABookingIdResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteOthMERABookingIdResults = this.addFavouriteOthMERABookingIdResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteOthMERABookingIdResults.push(obj);
        });

        this.addFavouriteOthMERABookingIdResults.forEach(obj => {
            obj.IsSelected = this.selectedOthMERABookingIdItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedOthMERABookingIdItems) {
            var uniqueData = this.addFavouriteOthMERABookingIdResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteOthMERABookingIdResults = arr;
            this.showFavouriteOthMERABookingIdList = true;
        }

        console.log(this.selectedOthMERABookingIdItems);
    }

    isOtherMERABookingsSelected(item: ReportVM): boolean {
        return this.selectedOthMERABookingIdItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchOthMERABookingId() {
        if (this.searchBarOthMERABookingId != null) {
            this.searchBarOthMERABookingId = String(this.searchBarOthMERABookingId).trim();
            if (this.searchBarOthMERABookingId.length >= 2) {
                this.addFavouriteOthMERABookingIdResults = [];
                this.showFavouriteOthMERABookingIdList = true;
                this.showSearchOthMERABookingIdLoader = true;
                this.othMERABookingId = new SearchBookingDto();
                this.othMERABookingId.SearchKey = String(this.searchBarOthMERABookingId).trim();

                this.othMERABookingId.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .SearchMERABooking(this.othMERABookingId)
                    .subscribe((data) => {
                        this.sortedOthMERABookingIdList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedOthMERABookingIdList.length > 0) {
                            this.results = this.sortedOthMERABookingIdList;
                            console.log(this.results);
                            this.results.forEach(aa => {
                                this.addFavouriteOthMERABookingIdResults.push({ ID: aa.MeraBookingId, Text: aa.MeraBookingId, Code: aa.MeraBookingId, IsSelected: false })
                            });
                            if (this.addFavouriteOthMERABookingIdResults) {
                                this.getOtherMERABookingsIdSortedData();
                            }
                            this.showSearchOthMERABookingIdLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouriteOthMERABookingIdResults = [];
                            this.showSearchOthMERABookingIdLoader = false;
                            this.IsDataNotFound = true;

                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarOthMERABookingId() {
        this.searchBarOthMERABookingId = '';
    }

    loadSelectedOthMERABookingIdItem() {
        if (this.selectedOthMERABookingIdItems) {
            if (this.selectedOthMERABookingIdItems.length > 0) {
                this.showFavouriteOthMERABookingIdList = true;
                this.getOtherMERABookingsIdSortedData();
            }
        }
    }


    // RetainBookingId

    loadSelectedOthBookingIdItem() {
        if (this.selectedOthBookingItems) {
            if (this.selectedOthBookingItems.length > 0) {
                this.showFavouriteOthBookingList = true;
                this.getOtherBookingsIdSortedData();
            }
        }
    }

    closeDivOtherRetainBookingId() {
        if (this.isRemoveSelectedOthRetainBookingIdItems == false) {
            this.addFavouriteOthBookingIdResults = [];
            this.showFavouriteOthBookingList = false;
        }
        else {
            this.isRemoveSelectedOthRetainBookingIdItems = false;
        }
        this.IsDataNotFound = false;
    }



    onOtherBookingsCheckboxChange(event: Event, item: ReportVM) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedOthBookingItems.push(item);
        } else {
            this.selectedOthBookingItems = this.selectedOthBookingItems.filter(selectedItem => selectedItem.ID !== item.ID);
        }
        this.getOtherBookingsIdSortedData();
    }

    private getOtherBookingsIdSortedData() {
        this.selectedOthBookingItems.forEach(obj => {
            if (this.addFavouriteOthBookingIdResults.some(a => a.ID == obj.ID)) {
                this.addFavouriteOthBookingIdResults = this.addFavouriteOthBookingIdResults.filter(selectedItem => selectedItem.ID !== obj.ID);
            }

            this.addFavouriteOthBookingIdResults.push(obj);
        });

        this.addFavouriteOthBookingIdResults.forEach(obj => {
            obj.IsSelected = this.selectedOthBookingItems.some(a => a.ID == obj.ID);
        });

        if (this.selectedOthBookingItems) {
            var uniqueData = this.addFavouriteOthBookingIdResults.filter((value, index, array) => array.indexOf(value) === index);
            let arr = uniqueData.sort((a, b) => (a.IsSelected > b.IsSelected ? -1 : 1));
            this.addFavouriteOthBookingIdResults = arr;
            this.showFavouriteOthBookingList = true;
        }

        console.log(this.selectedOthBookingItems);
    }

    isOtherBookingsSelected(item: ReportVM): boolean {
        return this.selectedOthBookingItems.some(selectedItem => selectedItem.ID === item.ID);
    }

    searchOthBookingId() {
        if (this.searchBarOthBookingId != null) {
            this.searchBarOthBookingId = String(this.searchBarOthBookingId).trim();
            if (this.searchBarOthBookingId.length >= 2) {
                this.addFavouriteOthBookingIdResults = [];
                this.showFavouriteOthBookingList = true;
                this.showSearchOthBookingLoader = true;
                this.othBookingId = new SearchBookingDto();
                this.othBookingId.SearchKey = String(this.searchBarOthBookingId).trim();

                this.othBookingId.InstanceId = this.selectedInstance;

                this.resourceListSubscription = this.reportService
                    .SearchBooking(this.othBookingId)
                    .subscribe((data) => {
                        this.sortedOthbookingIdList = this.orderPipe.transform(
                            data,
                            'ResourceName'
                        );
                        if (this.sortedOthbookingIdList.length > 0) {
                            this.results = this.sortedOthbookingIdList;

                            this.results.forEach(aa => {
                                this.addFavouriteOthBookingIdResults.push({ ID: aa.BookingId, Text: aa.BookingId, Code: aa.BookingId, IsSelected: false })
                            });
                            if (this.addFavouriteOthBookingIdResults) {
                                this.getOtherBookingsIdSortedData();
                            }
                            this.showSearchOthBookingLoader = false;
                        } else {
                            this.results = [];
                            this.addFavouriteOthBookingIdResults = [];
                            this.showSearchOthBookingLoader = false;
                            this.IsDataNotFound = true;
                        }
                    });
            } else {
                this.results = [];
            }
        } else {
            this.results = [];
        }
    }

    resetfiltersearchBarOthBookingId() {
        this.searchBarOthBookingId = '';
    }
    GetResourceDetails() {
        this.loggedInResourceDetails = new ResourceDetailsDto();
        return new Promise<void>((resolve, reject) => {
            this.reportService.GetResourceDetails(this.selectedInstance).subscribe(
                (data) => {
                    this.loggedInResourceDetails = data; // Set values to controls
                    resolve();
                    this.sleep(500).then(() => {
                    });
                },
                (error) => {
                    reject();
                },
                () => {
                    console.log('ResourceDetails data fetched');
                    this.loadDropDownData();
                    if (this.isUpdate == false && this.isCSULoggedIn && this.loggedInResourceDetails != null) {
                        if (this.showResIncludeDummyResources) {
                            this.includeDummyResources = this.loggedInResourceDetails.IncludeDummyResources;
                            this.includeDummyResourcesModel = this.includeDummyResources === true ? 'yes' : 'no';
                        }
                        if (this.showResResource && this.loggedInResourceDetails.ResourceId > 0)
                            this.selectedResItems = [{ ID: this.loggedInResourceDetails.ResourceId, Text: this.loggedInResourceDetails.ResourceName, Code: this.loggedInResourceDetails.ResourceName }];
                        if (this.showResCounsellor && this.loggedInResourceDetails.CouncellorName != null && this.loggedInResourceDetails.CouncellorName != '')
                            this.selectedCounsellorItems = [{ ID: 0, Text: this.loggedInResourceDetails.CouncellorName, Code: this.loggedInResourceDetails.CouncellorName }];
                        if (this.showResCountry && this.loggedInResourceDetails.CountryId > 0) {
                            this.resManageCountrySelectedItems = [{ ID: this.loggedInResourceDetails.CountryId, Text: this.loggedInResourceDetails.Country }];
                        }
                        if (this.showResServiceLine && this.loggedInResourceDetails.ServicelineId > 0) {
                            this.resServiceLineSelectedItems = [{ ID: this.loggedInResourceDetails.ServicelineId, Text: this.loggedInResourceDetails.ServiceLine }];
                        }
                        // if (this.showEngEngagementRegion && this.loggedInResourceDetails.EngagementRegionId > 0) {
                        //     this.engRegionSelectedItems = [{ ID: this.loggedInResourceDetails.EngagementRegionId, Text: this.loggedInResourceDetails.EngagementRegion }];
                        // }
                        if (this.showResRank && this.loggedInResourceDetails.RankID > 0) {
                            this.resRankSelectedItems = [{ ID: this.loggedInResourceDetails.RankID, Text: this.loggedInResourceDetails.Rank , Code:this.loggedInResourceDetails.Rank}];
                        }
                        if (this.showResGDSRegionAlignment && this.loggedInResourceDetails.GDSRegionAllignmentId > 0) {
                            this.resGDSRegionAlignmentSelectedItems = [{ ID: this.loggedInResourceDetails.GDSRegionAllignmentId, Text: this.loggedInResourceDetails.GDSRegionAllignment }];
                        }
                        if (this.showResSubServiceLine && this.loggedInResourceDetails.SubServiceLineId > 0) {
                            this.resSubServiceLineSelectedItems = [{ ID: this.loggedInResourceDetails.SubServiceLineId, Text: this.loggedInResourceDetails.SubServiceLine }];
                        }
                        if (this.showResCompetency && this.loggedInResourceDetails.CompetencyId > 0) {
                            this.resCompetencySelectedItems = [{ ID: this.loggedInResourceDetails.CompetencyId, Text: this.loggedInResourceDetails.Competency }];
                        }
                        if (this.showResCompanyCode && this.loggedInResourceDetails.CompanyCodeId > 0) {
                            this.resCompanyCodeSelectedItems = [{ ID: this.loggedInResourceDetails.CompanyCodeId, Text: this.loggedInResourceDetails.CompanyCode }];
                        }
                        if (this.showResCostCenter && this.loggedInResourceDetails.CostcenterId > 0) {
                            this.resViewCostCenterSelectedItems = [{ ID: this.loggedInResourceDetails.CostcenterId, Text: this.loggedInResourceDetails.CostCenter }];
                        }
                        if (this.showResEmployeeDepartment && this.loggedInResourceDetails.EmployeeDepartmentId > 0) {
                            this.selectedResEmployeeDepartmentItems = [{ ID: this.loggedInResourceDetails.EmployeeDepartmentId, Text: this.loggedInResourceDetails.EmployeeDepartment, Code: this.loggedInResourceDetails.EmployeeDepartmentCode }];
                        }
                        if (this.showResEconomicLocation && this.loggedInResourceDetails.EconomicLocationId > 0) {
                            this.resEconomicLocationSelectedItems = [{ ID: this.loggedInResourceDetails.EconomicLocationId, Text: this.loggedInResourceDetails.EconomicLocation }];
                        }
                        if (this.showResOfficeLocation && this.loggedInResourceDetails.OffliceLocationId > 0) {
                            this.resOfficeLocationSelectedItems = [{ ID: this.loggedInResourceDetails.OffliceLocationId, Text: this.loggedInResourceDetails.OffliceLocation }];
                        }
                    }
                }
            );
        });
    }
    calculateDaysBetweenDates(startDate: Date, endDate: Date): number {
        const oneDayInMs = 24 * 60 * 60 * 1000; // milliseconds in a day
        const start = startDate.getTime();
        const end = endDate.getTime();
        const differenceInMs = end - start;
        const differenceInDays = Math.round(differenceInMs / oneDayInMs);
        // Add 1 to include both the start date and the end date
        return differenceInDays + 1;
    }

    onScroll(){
        this.reportService.triggerNavigateToReportparent();
       }
}
